import { NgClass, NgOptimizedImage } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NumberCommaPipe } from '../../pipes/number-comma.pipe';
import { DuoActionDialogComponent } from '../../shared/components/dialogs/duo-action-dialog/duo-action-dialog.component';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import {
  ID_LOGIN_TYPE,
  TRENDING_EXAM_DEPT_NAME,
} from '../../shared/constants/common.constants';
import {
  AddExamInfo,
  AnesthesiaInfo,
  ChangeItem,
  CheckSuggestionsBundleRequest,
  CheckSuggestionsBundleResponse,
  ExamDetail,
  ExamItemInfo,
  RemoveItem,
  RequiredItemsRequest,
} from '../../shared/interfaces/reserve-add.model';
import {
  BusinessExamInfo,
  BusinessPackageInfo,
  ExamInfo,
  Group,
  GroupInfo,
  UserPlanResponse,
} from '../../shared/interfaces/reserve-loading.model';
import { ReserveAddService } from '../../shared/services/reserve-add.service';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { Question } from '../../shared/interfaces/appointment-confirm.model';
import Decimal from 'decimal.js';
import { Observable,of,take } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppointmentDiscountRateService } from '../../shared/services/appointment-discountRate.service';
import { CheckSuggestionsEnterpriseRequest, CheckSuggestionsEnterpriseResponse } from '../../shared/interfaces/dialogs/business-reserve-add.model';
import { BusinessReserveAddService } from '../../shared/services/business-reserve-add.service';
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { HostListener } from '@angular/core';
import { TagComponent } from '../../shared/components/tag/tag.component';
import { TextComponent } from '../../shared/components/text/text.component';
import { CartStateService } from '../../shared/services/cart-state.service';
import { ChangeExamItemDialogComponent } from '../../shared/components/dialogs/change-examItem-dialog/change-examItem-dialog.component';

/**
 * 加選項目組件
 */
@Component({
  selector: 'app-new-reserve-add',
  standalone: true,
  imports: [
    TranslatePipe,
    FormsModule,
    MatCheckbox,
    MatButton,
    NgClass,
    MatIconButton,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    NumberCommaPipe,
    NgOptimizedImage,
    MatTabGroup,
    MatTab,
    TagComponent,
    TextComponent,
    MatTooltipModule
  ],
  templateUrl: './new-reserve-add.component.html',
  styleUrl: './new-reserve-add.component.scss',
})
export class NewReserveAddComponent implements OnInit, OnDestroy {
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  reserveAddService: ReserveAddService = inject(ReserveAddService);
  translateService: TranslateService = inject(TranslateService);
  appointmentDiscountRateService: AppointmentDiscountRateService = inject(AppointmentDiscountRateService);
  businessReserveAddService: BusinessReserveAddService = inject(BusinessReserveAddService);
  router: Router = inject(Router);
  dialog: MatDialog = inject(MatDialog);
  cartStateService: CartStateService = inject(CartStateService);
  
  // 公開 Number 和 Math 供模板使用
  protected readonly Number = Number;
  hotExamDetail: ExamDetail[] = [];

  /**
   * 查詢種類
   * 1: 異常追蹤
   * 2: 潛在疾病
   * 3: 了解身體更多
   * 4: 快速搜查
   */
  private _searchType: number = 0;
  get searchType(): number {
    return this._searchType;
  }

  set searchType(value: number) {
    if (this._searchType !== value) {
      this._searchType = value;
      this.onSelectTypeChange(value);
    }
  }

  // 分類篩選下拉選單開關
  isDeptFilterOpen: boolean = false;

  // 已選擇的科別名稱(多選)
  selectedDeptNames: Array<string> = [];

  // API拿到的 所有的可添加檢項
  allExamDetail: Array<Array<ExamDetail>> = [];
  // 當前選擇的類別顯示的添加檢項 (異常追蹤/潛在疾病/了解身體更多/快速搜查)
  examInfoList: Array<AddExamInfo> = [];
  // 互斥檢項
  mutexInfos: Set<string> = new Set<string>();
  // 使用者勾選的加選檢查項目
  checkedExamInfoList: Array<AddExamInfo> = [];
  // 應付金額
  paymentAmount: number = 0;

  // 用戶主動移除的方案檢項
  removeItemQuestionMap: Array<ExamInfo> = [];

  // 是否應該顯示個人歷史異常追蹤的tab
  shouldShowAbnormal: boolean = false;
  // 是否應該顯示優先必要檢查項目的tab
  shouldShowBasic: boolean = false;

  // 快速搜索查詢名稱
  quickSearchText: string = '';
  // 快速搜索選擇之類別
  quickSearchSelectedDeptName: string = '';
  // 所有快速搜索類別
  quickSearchDeptNames: Array<string> = [];

  //方案檢項的 examType文字(0: "優先必要檢查項目",1: "潛在疾病風險檢查建議",2: "相依項目")
  examTypeText:  Array<string> = [];

  // 選擇placeholder
  selectedValue: string | null = null;

  //客戶方案類型0：修改(會員中心使用) / 1：全方位2：智能 / 3：安心起步
  planType: string = '0';
  // 選擇之方案
  selectedPackage: string = '';
  // 方案底下的所有檢項(會隨使用者者加減項目而變化)
  examInfoListUnderPackage: Array<ExamInfo> = [];
  // 方案底下的所有檢項(按照examType分類) 前端購物車顯示用
  examInfoListUnderPackageByType: Map<string, Map<string, Array<ExamInfo>>> =
    new Map();
  // 勾選的方案底下檢項 (只顯示examItem)
  checkedExamItemListUnderPackage: Array<string> = [];

  // 取得加選項目response
  checkSuggestionsResponse?: CheckSuggestionsBundleResponse;

  // 取得企業加選項目response
  checkSuggestionsEnterpriseResponse?: CheckSuggestionsEnterpriseResponse;

  //標準檢查項目
  translatedStandardType = this.translateService.instant(
    'reserve-result.standard'
  );

  // 是否為會員中心來的個人方案
  isPersonal: boolean = false;
  // 企業方案組合檢項
  businessGroupUnderPackageByDept: Map<string, Array<Group>> = new Map();
  // 勾選的企業方案組合檢項
  checkedBusinessGroupUnderPackage: Array<Group> = [];
  // 企業方案檢項
  businessExamInfoUnderPackageByDept: Map<string, Array<BusinessExamInfo>> =
    new Map();
  // 勾選的企業方案檢項
  checkedBusinessExamInfoUnderPackage: Array<BusinessExamInfo> = [];

  // allCheckupDiscountRate: string = ''; // 全方位方案折扣率
  // aiExclusiveDiscountRate: string = ''; // 智能專屬方案折扣率
  // basicCheckupDiscountRate: string = ''; // 基礎方案折扣率

  partyDiscountRate: string = ''; // 活動折扣率

  userPlanResponse?: UserPlanResponse;

  // 麻醉選擇結果：0 = 不要麻醉 ,1 = 需要麻醉, 2 = 不需詢問, undefined=尚未選擇
  anesthesiaChoice: number | undefined = undefined;

  // 原始總價
  originalPrice = new Decimal(0);

  selectedTab: number = 0;

  isFromMemberCenter: boolean = false;

  // 顯示方案金額(負數轉正)
  protected readonly Math = Math;

  // 方案是否展開
  isPackageOpen: boolean = true;
  // 加選是否展開
  isAddPackageOpen: boolean = true;

  // deptName是否展開 { deptName: isOpen }
  isDeptNameOpen: Map<string, boolean> = new Map();

  // examType底下deptName是否展開 { examType: { deptName: isOpen } }
  isDeptNameOpenByExamType: Map<string, Map<string, boolean>> = new Map();

  // 側邊欄收合
  @ViewChild('reserveAddRightCart', { static: false })
  reserveAddRightCart!: ElementRef;
  @ViewChild('reserveAddLeftPage', { static: false })
  reserveAddLeftPage!: ElementRef;

  // 加入載入狀態
  isLoadingBusinessSuggestions = false;

  isLoadingPersonalSuggestions = false;

  isOverflow = false;

  // 檢查購物車在手機尺寸時，應顯示的文字
  isMobile = false;

  // 套檢金額
  originalPackagePrice: number = 0;

  
  // 購物車是否開啟
  isCartOpen = false;

  // 保存原始的互斥項目
  originalMutexInfos: Set<string> = new Set();

  private resizeObserver?: ResizeObserver;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
    
    // 將當前預約步驟設置為4
    setTimeout(() => {
      this.sharedStorageService.set('reserveStep', 4);
    });

    // 判斷是否為會員中心來的調整檢項-個人
    const modifyType = this.sharedStorageService.get('modifyType') ?? null;
    const reserveType = this.sharedStorageService.get('reserveType');// 1: 個人 2: 企業
    if (modifyType === 'modifyExam' && reserveType === '1') {
      // 個人-會員中心調整檢項-僅可加選，不可退選方案中的檢項
      this.isFromMemberCenter = true;
    } else if (modifyType === 'modifyExam' && reserveType === '2') {
      // 取得原始套檢金額
      this.originalPackagePrice = this.sharedStorageService.get('originalPackagePrice') ?? 0;
      // 企業-會員中心調整檢項-可加可減
      this.isFromMemberCenter = true;
    }else {
      this.isFromMemberCenter = false;
    }

    this.userPlanResponse = this.sharedStorageService.get('userPlanResponse');

    // // 設置原始總價，取得前一頁還未折扣前的方案價格
    this.originalPrice = new Decimal(this.sharedStorageService.get('originalPrice') ?? 0);

    // 如果是從下一頁回來，由selectFlag = 1來判斷方案原價
    const examItemListForPrice: ExamInfo[] = this.sharedStorageService.get('examItemList') ?? [];
    if (examItemListForPrice.length > 0) {
      // 計算已選檢項的原始總價（只計算 selectFlag === 1 的檢項）
      const selectedItemsPrice = examItemListForPrice
        .filter(examInfo => (examInfo.selectFlag ?? 1) === 1)
        .reduce((total, examInfo) => {
          return total.add(new Decimal(examInfo.examPrice ?? 0));
        }, new Decimal(0));
      
      // 使用已選檢項的總價作為原始價格
      this.originalPrice = selectedItemsPrice;
      console.log("使用已選檢項計算的 originalPrice:", this.originalPrice.toString());
    }

    // 初始化用戶移除的方案檢項
    this.removeItemQuestionMap = this.sharedStorageService.get('removeItemQuestionMap') || [];

    const userPlanRequest = this.sharedStorageService.get('userPlanRequest');

    const partyDiscountRate = this.sharedStorageService.get('partyDiscountRate') ?? '';

    // 測試無感腸胃鏡用
    // const testExamItem = {
    //   examName: 'LB000401V',
    //   examItem: 'LB000401V',
    //   examMemo: '測試用途',
    //   price: '1000',
    //   mutexInfos: [],
    //   isNecessary: false,
    //   isChoice: true,
    //   disable: false,
    //   examType: '',
    //   deptName: '',
    //   deptEName: '',
    // }

    // if (!this.checkedExamInfoList.some(item => item.examItem === testExamItem.examItem)) {
    //   this.checkedExamInfoList.push(testExamItem);
    // }

    // 如果有活動折扣率，則套用活動折扣
    if (partyDiscountRate) {
      this.partyDiscountRate = partyDiscountRate;
    }
    // 給予後端使用者選擇的方案
    if (this.sharedStorageService.get('reserveType') === '2') {
      this.selectedPackage = this.sharedStorageService.get('businessSelectedPackage')?.packageName ?? '';
    } else {
      this.selectedPackage = this.sharedStorageService.get('selectedPackage') ?? '';
    }
    const examItemList: ExamInfo[] = this.sharedStorageService.get('examItemList') ?? [];
    const selectedPackagePlanType = this.sharedStorageService.get('selectedPackagePlanType');
    const businessPlanRequest = this.sharedStorageService.get('businessPlanRequest');
    const businessSelectedPackage = this.sharedStorageService.get('businessSelectedPackage');

    if (selectedPackagePlanType) {
      // 如果有 selectedPackagePlanType，優先使用它
      this.planType = selectedPackagePlanType;
      console.log('this.planType (from selectedPackagePlanType)', this.planType);
    } else {
      // 根據預約類型設定不同的 planType 邏輯
      if (this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL) {
        // 個人預約：根據方案名稱設定 planType
        if (
          this.selectedPackage === this.translateService.instant('reserve-result.all-checkup')
        ) {
          this.planType = '1';
        } else if (
          this.selectedPackage === this.translateService.instant('reserve-result.ai-exclusive')
        ) {
          this.planType = '2';
        } else if (
          this.selectedPackage === this.translateService.instant('reserve-result.basic-checkup')
        ) {
          this.planType = '3';
        }
        this.sharedStorageService.set('selectedPackagePlanType', this.planType);
      } else {

        if (modifyType === 'modifyExam') {
          // 從會員中心調整檢項
          this.planType = '0';
          console.log('來自會員中心，planType = 0');
        } else {
          // 從預約流程(上一頁)來的
          this.planType = '1';
          console.log('來自預約流程，planType = 1');
        }
      }
    }
    // 企業預約
    if (this.sharedStorageService.get('reserveType') === '2') {
      // 取得方案原始金額
      this.paymentAmount = Number(businessSelectedPackage?.price) ?? 0;
      const businessPlanResponse = this.sharedStorageService.get('businessPlanResponse');
      let sponsorAmt = 0;
      // 若從會員中心來
      if (this.planType === '0') {
        
        sponsorAmt =Number(this.sharedStorageService.get('sponsorAmt')) ?? 0;
        // 從會員中心來調整檢項
        console.log('企業預約 - 來自會員中心，從 localStorage 取得 sponsorAmt:', sponsorAmt);
        const examItemList = this.sharedStorageService.get('examItemList') ?? [];
        
        if (examItemList.length > 0) {
          this.examInfoListUnderPackage = examItemList.map((examInfo: ExamInfo) => ({
            ...examInfo,
            deptName: examInfo.deptName,
            selectFlag: examInfo.selectFlag ?? 1,
            disable: examInfo.examType === this.examTypeText[0],
          }));
          
          this.checkedExamItemListUnderPackage = this.examInfoListUnderPackage
            .filter((examInfo: ExamInfo & { selectFlag?: number }) => examInfo.selectFlag === 1)
            .map((examInfo: ExamInfo) => examInfo.examItem);
          
          console.log('從會員中心 - examInfoListUnderPackage:', this.examInfoListUnderPackage);
          console.log('從會員中心 - checkedExamItemListUnderPackage:', this.checkedExamItemListUnderPackage);
        } else {
          console.warn('從會員中心來,但 examItemList 是空的!');
        }

      } else {
        sponsorAmt = Number(businessPlanResponse?.companyInfo.sponsorAmt) ?? 0;
      }
      // 如果有補助金額，需要扣掉
      if (sponsorAmt > 0) {
        this.paymentAmount -= sponsorAmt;
      }

      // 如果有加選項目，需要加回加選金額
      const addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
      const addExamPrice = addExamItemList.reduce((total, item) => {
        return total + (Number(item.price) || 0);
      }, 0);
      this.paymentAmount += addExamPrice;

      this.isPersonal = false;
      const checkSuggestionsEnterpriseRequest: CheckSuggestionsEnterpriseRequest = {
        orgNo: businessPlanRequest?.orgNo ?? '',
        companyNo: businessPlanRequest?.companyNo ?? '',
        packageNo: businessSelectedPackage?.packageNo ?? '',
        dayType: businessSelectedPackage?.dayType ?? '',
        bookPeriod: businessSelectedPackage?.bookPeriod ?? '',
        planType: this.planType ?? '1',
        gender: businessPlanRequest?.gender ?? '',
        idNo: userPlanRequest?.idNo ?? '',
        age: this.planType === '0' ? '' : userPlanRequest?.age ?? '',
        isPregnant: this.planType === '0' ? false : userPlanRequest?.femaleStatus ?? false,
        isMenopausal: this.planType === '0' ? false : userPlanRequest?.femaleMenopausal ?? false,
        examItemList: examItemList.map(examItem => examItem.examItem),
        history: this.planType === '0' ? [] : userPlanRequest?.history ?? [],
        family: this.planType === '0' ? [] : userPlanRequest?.family ?? [],
        subjectiveSymptoms: this.planType === '0' ? [] : userPlanRequest?.subjectiveSymptoms ?? [],
        questionnaireId: 20,
        entQuestionnaireId: 681,
        fractureAnswer: userPlanRequest?.fractureAnswer ?? '',
        cancerAnswer: userPlanRequest?.cancerAnswer ?? '',
        addList: [],
      };
      console.log('checkSuggestionsEnterpriseRequest:', checkSuggestionsEnterpriseRequest);

      // 設定載入狀態為 true
      this.isLoadingBusinessSuggestions = true;
      
      // 取得企業加選推薦項目 CB-034
      this.businessReserveAddService.getBusinessAddSuggestion(checkSuggestionsEnterpriseRequest).subscribe(res => {
        if (res.success && res.data) {
          this.checkSuggestionsEnterpriseResponse = res.data;
          
          this.hotExamDetail = this.checkSuggestionsEnterpriseResponse.hotExamItemDetail || [];
          this.allExamDetail.push(this.checkSuggestionsEnterpriseResponse.abnormalDetail);
          this.allExamDetail.push(this.checkSuggestionsEnterpriseResponse.potentialDetail);
          this.allExamDetail.push(this.checkSuggestionsEnterpriseResponse.basicCheckup); // 對應個人的 bodyInsightDetail 位置
          this.allExamDetail.push(this.checkSuggestionsEnterpriseResponse.addExamDetail);
          console.log('allExamDetail:', this.allExamDetail);


          // 判斷企業預約tab顯示邏輯
          if (this.checkSuggestionsEnterpriseResponse.abnormalDetail && this.checkSuggestionsEnterpriseResponse.abnormalDetail.length > 0) {
            console.log('有abnormalDetail');
            
            
            // 使用 setTimeout 確保在下一個變更檢測週期更新
            setTimeout(() => {
              this.shouldShowAbnormal = this.shouldShowAbnormalTrackingButton;
              this.shouldShowBasic = this.shouldShowBasicCheckupButton;
              
              console.log('shouldShowAbnormal 結果:', this.shouldShowAbnormal);
              console.log('shouldShowBasic 結果:', this.shouldShowBasic);
              
              if (this.shouldShowAbnormal) {
                console.log('應該顯示個人歷史異常追蹤tab');
                this.searchType = 1;
              } else {
                console.log('不應該顯示個人歷史異常追蹤tab');
                this.searchType = 2;
              }
              console.log('最終 searchType:', this.searchType);
            });
          }
          else if(this.checkSuggestionsEnterpriseResponse.potentialDetail && this.checkSuggestionsEnterpriseResponse.potentialDetail.length > 0) {
            console.log('有potentialDetail');
            this.searchType = 2;
          } 
          else if (this.checkSuggestionsEnterpriseResponse.basicCheckup && this.checkSuggestionsEnterpriseResponse.basicCheckup.length > 0) {
            console.log('有basicCheckup');
            if (this.shouldShowBasicCheckupButton) {
              console.log('應該顯示優先必要檢查項目tab');
              this.searchType = 3;
            } else {
              console.log('不應該顯示優先必要檢查項目tab');
              this.searchType = 2;
            }
          } else {
            // 只有當前面所有資料都沒有時，才預設選擇快速搜尋
            console.log('searchType', this.searchType);
            this.searchType = 4;
          }

          // 初始化已選項目，如果localstorage有值(基本上選方案後就會有值)
          if (examItemList.length > 0) {
            // 建立 examItem 到 deptName 的映射表
            const examItemToDeptNameMap = new Map<string, string>();
            this.checkSuggestionsEnterpriseResponse.addExamDetail?.forEach(examDetail => {
              examDetail.examItemList?.forEach(examInfo => {
                examItemToDeptNameMap.set(examInfo.examItem, examDetail.deptName);
              });
            });

            this.examInfoListUnderPackage = examItemList.map((examInfo: ExamInfo) => ({
              ...examInfo,
              deptName: examInfo.deptName || examItemToDeptNameMap.get(examInfo.examItem),
              selectFlag: examInfo.selectFlag ?? 1, // 沒有 selectFlag → 預設 1，因從選方案時到這頁時還沒有selectFlag
            }));
            this.checkedExamItemListUnderPackage = this.examInfoListUnderPackage
              .filter((examInfo: ExamInfo & { selectFlag?: number }) => examInfo.selectFlag === 1)
              .map((examInfo: ExamInfo) => examInfo.examItem);
            console.log('企業預約 - 抓localstorage:', this.examInfoListUnderPackage);
            console.log('企業預約 - checkedExamItemListUnderPackage:', this.checkedExamItemListUnderPackage);
          }
      
          // 初始化互斥檢項
          if (res.data?.planList.length > 0) {
            this.initializeMutexInfos(res.data);
          }

          // 初始化購物車
          // 統一 deptName 格式的函數
          const normalizeDeptName = (deptName: string): string => {
            // 移除英文部分，只保留中文
            return deptName.replace(/\([^)]*\)/g, '').trim();
          };

          this.examInfoListUnderPackageByType =
          this.examInfoListUnderPackage
          .reduce((typeMap, examInfo) => {
            const type = examInfo.examType ?? 'unknown';
            const dept = normalizeDeptName(examInfo.deptName ?? 'unknown');
            if (!typeMap.has(type)) {
              typeMap.set(type, new Map<string, ExamInfo[]>());
            }
            const deptMap = typeMap.get(type)!;
            if (!deptMap.has(dept)) {
              deptMap.set(dept, []);
            }
            deptMap.get(dept)!.push(examInfo);
            return typeMap;
          }, new Map<string, Map<string, ExamInfo[]>>());

          console.log('企業預約 - 初始化examInfoListUnderPackageByType:', this.examInfoListUnderPackageByType);

          // 判斷：若方案內有雙項麻醉DAn，且加選有SAn，則將方案內的麻醉DAn反灰不給選擇
          const danExamItem = this.getAnesthesiaExamItem('dAn');
          const sanExamItem = this.getAnesthesiaExamItem('sAn');

          // 檢查方案內是否有雙項麻醉
          const packageHasDAn = danExamItem && danExamItem.some(danItem =>
            this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)
          );

          // 檢查加選是否有單項麻醉
          const addedHasSAn = sanExamItem && sanExamItem.some(sanItem =>
            this.checkedExamInfoList.some(examInfo => examInfo.examItem === sanItem)
          );

          // 若方案內有DAn且加選有SAn，則將方案內的DAn加入互斥檢項（反灰）
          if (packageHasDAn && addedHasSAn && danExamItem) {
            danExamItem.forEach(danItem => {
              // 只有當該DAn在方案內時才加入互斥
              if (this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)) {
                this.mutexInfos.add(danItem);
                console.log('企業預約 - 因加選有SAn，將方案內的DAn反灰:', danItem);
              }
            });
          }

          // 勾選已選檢查項目
          if (this.sharedStorageService.has('addExamItemList')) {
            this.checkedExamInfoList =
            this.sharedStorageService.get('addExamItemList') ?? [];
        
            // 過濾空內容或價格為0的無效項目
            this.checkedExamInfoList = this.checkedExamInfoList.filter(
              item => item.examName && item.price && Number(item.price) > 0
            );
            this.checkedExamInfoList.forEach(addExamInfo => {
              addExamInfo.mutexInfos?.forEach(mutexInfo => {
                this.mutexInfos.add(mutexInfo);
              }); // 添加互斥檢項
            });
          }
        }
        // API 回傳後設定載入狀態為 false
        this.isLoadingBusinessSuggestions = false;
      });
    } else {
      // 個人預約
      let request: CheckSuggestionsBundleRequest = {
      orgNo: userPlanRequest?.orgNo ?? '',
      gender: userPlanRequest?.gender ?? '',
      idNo: userPlanRequest?.idNo ?? '',
      identityType: userPlanRequest?.identityType ?? '0',
      planType: this.planType ?? '0', 
      };

      this.isLoadingPersonalSuggestions = true;

      if(this.planType === '0') {
        //從會員中心來調整檢項的
        if (
            this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL
          ){
          //個人
          this.isPersonal = true;
          //修改CB-047 request格式
          const addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
          request= {
            ...request,
            examItemList: examItemList.map(examItem => examItem.examItem),
            addList: addExamItemList.map(addExamItem => addExamItem.examItem),
          };

        } else {
          //企業
          this.isPersonal = false;
        }
      }
      // 取得所有添加檢項，並依序添加至allExamInfoList
      this.reserveAddService.checkSuggestionsBundle(request).pipe(take(1)).subscribe(res => {
       this.checkSuggestionsResponse = res.data;
        console.log('checkSuggestionsResponse', this.checkSuggestionsResponse);
        if (this.checkSuggestionsResponse) {
          this.initializeMutexInfos(this.checkSuggestionsResponse);
          console.log('初始化互斥檢項完成', this.mutexInfos);

          // // 假資料測試
          // const planList = [
          //   {
          //     "examItem": "F0000002",
          //     "isNecessary": true,
          //     "mutexInfos": []
          //   },
          //   {
          //     "examItem": "H0000003",
          //     "isNecessary": true,
          //     "mutexInfos": []
          //   },
          //   {
          //     "examItem": "NC000109",
          //     "isNecessary": true,
          //     "mutexInfos": []
          //   },
          // ];

          console.log('this.checkSuggestionsResponse.planList:', this.checkSuggestionsResponse?.planList);

          // 處理 planList 中的 isNecessary 屬性
          if (this.checkSuggestionsResponse?.planList && this.checkSuggestionsResponse?.planList.length > 0) {
            // 取得 SharedStorage 中的原始 examItemList
            const originalExamItemList = this.sharedStorageService.get('examItemList') || [];
            
            this.checkSuggestionsResponse.planList.forEach(planItem => {
              const matchedExam = this.examInfoListUnderPackage.find(
                examInfo => examInfo.examItem === planItem.examItem
              );
              
              if (matchedExam) {
                // 找出 SharedStorage 中的原始資料
                const originalExam = originalExamItemList.find(
                  (item: ExamInfo) => item.examItem === planItem.examItem
                );
                
                // 檢查原始 selectFlag 是否存在且為 1
                const hasOriginalSelectFlag = originalExam && originalExam.selectFlag !== undefined;
                const originalSelectFlagIs1 = hasOriginalSelectFlag && originalExam.selectFlag === 1;
                
                // 根據 planList 的 isNecessary 設定
                if (planItem.isNecessary) {
                  // 只有在以下情況才設為必選:
                  // 1. 沒有原始 selectFlag (第一次進入) → 設為 1
                  // 2. 有原始 selectFlag 且為 1 → 保持 1
                  // 3. 有原始 selectFlag 且為 0 → 保持 0 (不改動)
                  if (!hasOriginalSelectFlag || originalSelectFlagIs1) {
                    matchedExam.selectFlag = 1;
                    matchedExam.isNecessary = planItem.isNecessary;
                    
                    if (!this.checkedExamItemListUnderPackage.includes(planItem.examItem)) {
                      this.checkedExamItemListUnderPackage.push(planItem.examItem);
                    }
                    console.log('設定必選項目:', planItem.examItem);
                  } else {
                    // 原始 selectFlag = 0,保持不變,但標記為必選 (不適合施作)
                    matchedExam.selectFlag = 0;
                    matchedExam.isNecessary = true; // 改為 true,表示這是必選但不適合施作
                    console.log('跳過已移除的必選項目:', planItem.examItem, 'selectFlag = 0, isNecessary = true');
                  }
                } else {
                  // 非必選項目
                  // 如果是 "優先必要檢查項目" 類型,仍然設為必檢
                  if (matchedExam.examType === this.examTypeText[0]) {
                    matchedExam.isNecessary = true;
                  } else {
                    matchedExam.isNecessary = false;
                  }
                  
                  // 保留原始的 selectFlag (可能是 0 或 1)
                  if (hasOriginalSelectFlag) {
                    matchedExam.selectFlag = originalExam.selectFlag;
                    console.log('保留非必選項目的 selectFlag:', planItem.examItem, 'selectFlag =', matchedExam.selectFlag);
                  }
                }
              }
            });
            
            // 重新同步 checkedExamItemListUnderPackage
            this.checkedExamItemListUnderPackage = this.examInfoListUnderPackage
              .filter((examInfo: ExamInfo & { selectFlag?: number }) => examInfo.selectFlag === 1)
              .map((examInfo: ExamInfo) => examInfo.examItem);
            
            console.log('處理 isNecessary 後的 examInfoListUnderPackage:', this.examInfoListUnderPackage);
          }

          if (this.checkSuggestionsResponse.addExamDetail) {
            this.checkSuggestionsResponse.addExamDetail.forEach(
              (examDetail, index) => {
                console.log(`addExamDetail[${index}]:`, {
                  deptName: examDetail.deptName,
                  deptEName: examDetail.deptEName,
                  examInfos數量: examDetail.examItemList?.length || 0,
                  examInfos內容: examDetail.examItemList,
                });
              }
            );
          }
          this.hotExamDetail = this.checkSuggestionsResponse.hotExamItemDetail || [];
          this.allExamDetail.push(this.checkSuggestionsResponse.abnormalDetail);
          this.allExamDetail.push(this.checkSuggestionsResponse.potentialDetail);
          this.allExamDetail.push(this.checkSuggestionsResponse.bodyInsightDetail);
          this.allExamDetail.push(this.checkSuggestionsResponse.addExamDetail);
          console.log('allExamDetail', this.allExamDetail);
          console.log('allExamDetail[3] (addExamDetail):', this.allExamDetail[3]);

          // 將searchType設為1(異常追蹤)
          this.searchType = 1;

          this.isLoadingPersonalSuggestions = false;
        }

        // tab顯示邏輯
        if (this.planType === '1') {
          this.searchType = 4;
        } else if (this.planType === '2') {
          this.searchType = 2;
        } else if (this.planType === '3') {
          // 如果沒有異常追蹤資料，則預設選擇潛在疾病(2)而非異常追蹤(1)
          this.searchType = this.hasAbnormalData ? 1 : 2;
          console.log("是否有異常追蹤資料hasAbnormalData",this.hasAbnormalData);
        }else if (this.planType === '0'){
          this.searchType = 4;  
        } else {
          // 其他情況也檢查是否有異常追蹤資料
          this.searchType = this.hasAbnormalData ? 1 : 2;
          
        }
      });
    
      if (
        this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL
      ) {
        // 個人預約

        this.paymentAmount = Number(this.sharedStorageService.get('packagePrice')) ?? 0;

        // 如果有加選項目，需要加回加選金額
        const addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
        const addExamPrice = addExamItemList.reduce((total, item) => {
          return total + (Number(item.price) || 0);
        }, 0);
        
        this.paymentAmount += addExamPrice;
        
        console.log("方案價格:", Number(this.sharedStorageService.get('packagePrice')));
        console.log("加選價格:", addExamPrice);
        console.log("總 paymentAmount:", this.paymentAmount);

        //初始化已選項目，如果localstorage有值(基本上選方案後就會有值)
        if(examItemList.length > 0){
          this.examInfoListUnderPackage = examItemList.map((examInfo: ExamInfo) => ({
            ...examInfo,
            deptName: examInfo.deptName,
            selectFlag: examInfo.selectFlag ?? 1, // 沒有 selectFlag → 預設 1，因從選方案時到這頁時還沒有selectFlag
          }));
          this.checkedExamItemListUnderPackage = this.examInfoListUnderPackage
            .filter((examInfo: ExamInfo & { selectFlag?: number }) => examInfo.selectFlag === 1)
            .map((examInfo: ExamInfo) => examInfo.examItem);
          console.log('抓localstorage:', this.examInfoListUnderPackage);
        }

        console.log(
          'examInfoListUnderPackage total:',
          this.examInfoListUnderPackage.length
        );
        console.log(
          'examInfoListUnderPackage:',
          this.examInfoListUnderPackage
        );
        this.examInfoListUnderPackage.forEach((examInfo, index) => {
          if (!examInfo.deptName) {
            console.log(`examInfo[${index}] 缺少 deptName:`, {
              examName: examInfo.examName,
              examItem: examInfo.examItem,
              deptName: examInfo.deptName,
              examType: examInfo.examType,
            });
          }
        });

        //初始化 examTypeText 並排序
        const examTypeOrder = ['優先必要檢查項目', '潛在疾病風險檢查建議'];
        const uniqueExamTypes = new Set<string>();
        this.examInfoListUnderPackage.forEach(examInfo => {
          if (examInfo.examType) {
            uniqueExamTypes.add(examInfo.examType);
          }
        });
        
        this.examTypeText = Array.from(uniqueExamTypes).sort((a, b) => {
          const indexA = examTypeOrder.indexOf(a);
          const indexB = examTypeOrder.indexOf(b);
          
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          
          return indexA - indexB;
        });
        
        //初始化購物車 - 先建立臨時 Map
        // 過濾規則:只排除 selectFlag = 0 且 isNecessary = true 的檢項
        const tempTypeMap = this.examInfoListUnderPackage
          .filter((examInfo: ExamInfo) => {
            // selectFlag = 1 → 顯示
            if (examInfo.selectFlag === 1) return true;
            
            // selectFlag = 0 且 isNecessary = false → 顯示 (可勾選)
            if (examInfo.selectFlag === 0 && !examInfo.isNecessary) return true;
            
            // selectFlag = 0 且 isNecessary = true → 不顯示 (不適合施作)
            return false;
          })
          .reduce((typeMap, examInfo) => {
            const type = examInfo.examType ?? 'unknown';
            const dept = examInfo.deptName ?? 'unknown';
            if (!typeMap.has(type)) {
              typeMap.set(type, new Map<string, ExamInfo[]>());
            }
            const deptMap = typeMap.get(type)!;
            if (!deptMap.has(dept)) {
              deptMap.set(dept, []);
            }
            deptMap.get(dept)!.push(examInfo);
            return typeMap;
          }, new Map<string, Map<string, ExamInfo[]>>());

        console.log('初始化購物車 - 過濾規則: 排除 selectFlag=0 且 isNecessary=true 的檢項');
        console.log('購物車檢項數量:', 
          Array.from(tempTypeMap.values())
            .flatMap(deptMap => Array.from(deptMap.values()))
            .flat().length
        );

        // 按照 examTypeText 的順序重新排列
        this.examInfoListUnderPackageByType = new Map();
        this.examTypeText.forEach(type => {
          if (tempTypeMap.has(type)) {
            this.examInfoListUnderPackageByType.set(type, tempTypeMap.get(type)!);
          }
        });
        
        // 處理不在 examTypeText 中的類型（如 'unknown'）
        tempTypeMap.forEach((value, key) => {
          if (!this.examInfoListUnderPackageByType.has(key)) {
            this.examInfoListUnderPackageByType.set(key, value);
          }
        });

        console.log(
          '初始化examInfoListUnderPackageByType:',
          this.examInfoListUnderPackageByType
        );
        console.log('examTypeText 順序:', this.examTypeText);

        // 判斷：若方案內有雙項麻醉DAn，且加選有SAn，則將方案內的麻醉DAn反灰不給選擇
        const danExamItem = this.getAnesthesiaExamItem('dAn');
        const sanExamItem = this.getAnesthesiaExamItem('sAn');

        // 檢查方案內是否有雙項麻醉
        const packageHasDAn = danExamItem && danExamItem.some(danItem =>
          this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)
        );

        // 檢查加選是否有單項麻醉
        const addedHasSAn = sanExamItem && sanExamItem.some(sanItem =>
          this.checkedExamInfoList.some(examInfo => examInfo.examItem === sanItem)
        );

        // 若方案內有DAn且加選有SAn，則將方案內的DAn加入互斥檢項（反灰）
        if (packageHasDAn && addedHasSAn && danExamItem) {
          danExamItem.forEach(danItem => {
            // 只有當該DAn在方案內時才加入互斥
            if (this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)) {
              this.mutexInfos.add(danItem);
              console.log('個人預約 - 因加選有SAn，將方案內的DAn反灰:', danItem);
            }
          });
        }

        // 檢查有 unknown 的項目
        for (const [
          examType,
          deptMap,
        ] of this.examInfoListUnderPackageByType.entries()) {
          for (const [deptName, examList] of deptMap.entries()) {
            if (deptName === 'unknown' || examType === 'unknown') {
              console.log(`unknown:`, {
                examType: examType,
                deptName: deptName,
                檢項數量: examList.length,
                檢項詳情: examList.map(exam => ({
                  examName: exam.examName,
                  examItem: exam.examItem,
                  originalDeptName: exam.deptName,
                  originalExamType: exam.examType,
                })),
              });
            }
          }
        }

        //卡片勾選判斷，從reserve-comfirm回來調整專案時初始化
        // this.checkedExamItemListUnderPackage =
        //   this.examInfoListUnderPackage
        //     .filter((examInfo: ExamInfo & { selectFlag?: number }) => examInfo.selectFlag === 1)
        //     .map((examInfo: ExamInfo) => examInfo.examItem);

        // 初始化dept是否展開
        for (let deptMap of this.examInfoListUnderPackageByType.values()) {
          for (let deptKey of deptMap.keys()) {
            this.isDeptNameOpen.set(deptKey, false);
          }
        }
      } else {
        // 企業預約
        // const businessSelectedPackage = this.sharedStorageService.get(
        //   'businessSelectedPackage'
        // );
        // if (businessSelectedPackage) {
        //   // 設置已選方案金額
        //   this.paymentAmount = Number(businessSelectedPackage.price);
        //   this.selectedPackage = businessSelectedPackage.packageName ?? '';

        //   // 設置購物車內容
        //   businessSelectedPackage.packageList.forEach(
        //     (businessPackageInfo: BusinessPackageInfo) => {
        //       const deptName = businessPackageInfo.deptName;
        //       this.businessExamInfoUnderPackageByDept.set(
        //         deptName,
        //         businessPackageInfo.examInfo
        //       ); // 添加businessExamInfo
        //       this.checkedBusinessExamInfoUnderPackage.push(
        //         ...businessPackageInfo.examInfo
        //       );

        //       if (businessPackageInfo.isGroup) {
        //         // 添加business組合檢項
        //         const groups: Array<Group> = [];
        //         businessPackageInfo.groupInfo.forEach((groupInfo: GroupInfo) => {
        //           groupInfo.groupList.forEach((group: Group) => {
        //             groups.push(group);
        //           });
        //         });
        //         this.businessGroupUnderPackageByDept.set(deptName, groups);
        //         this.checkedBusinessGroupUnderPackage.push(...groups);
        //       }
        //     }
        //   );
        // }

        // // 初始化dept是否展開
        // for (let deptName of this.sharedStorageService
        //   .get('businessSelectedPackage')
        //   ?.packageList.map(
        //     businessPackageInfo => businessPackageInfo.deptName
        //   ) ?? []) {
        //   this.isDeptNameOpen.set(deptName, false);
        // }
      }

      // 勾選已選檢查項目
      if (this.sharedStorageService.has('addExamItemList')) {
        this.checkedExamInfoList =
          this.sharedStorageService.get('addExamItemList') ?? [];
        
        // 過濾空內容或價格為0的無效項目
        this.checkedExamInfoList = this.checkedExamInfoList.filter(
          item => item.examName && item.price && Number(item.price) > 0
        );
        this.checkedExamInfoList.forEach(addExamInfo => {
          addExamInfo.mutexInfos?.forEach(mutexInfo => {
            this.mutexInfos.add(mutexInfo);
          }); // 添加互斥檢項
          // this.paymentAmount += Number(addExamInfo.price); // 累加應付金額
        });
      }

      this.debugExamTypes();
    }

  }

  ngOnDestroy(): void {
    // 清理 ResizeObserver
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private setupViewportHeightTracking(): void {
    // 設定 CSS 變數來追蹤實際視窗高度
    const updateViewportHeight = () => {
      const vh = window.visualViewport?.height || window.innerHeight;
      document.documentElement.style.setProperty('--viewport-height', `${vh}px`);
    };

    // 初始設定
    updateViewportHeight();

    // 監聽視窗變化
    window.visualViewport?.addEventListener('resize', updateViewportHeight);
    window.addEventListener('resize', updateViewportHeight);
    
    // 監聽滾動 (某些瀏覽器需要)
    window.addEventListener('scroll', updateViewportHeight, { passive: true });
  }

  // 選擇查詢種類(異常追蹤/潛在疾病/了解身體更多/快速搜查)
  onSelectTypeChange(newType: number) {
    // 清空顯示的examInfo
    this.examInfoList = [];

    const examDetailList = this.allExamDetail[newType - 1];

    if (!examDetailList) {
      console.warn(`examDetailList for type ${newType} is undefined`);
      return;
    }
    if(this.planType === '0'){
        //從會員中心來調整檢項的
      examDetailList.forEach(examDetail => {
        const deptName = examDetail.deptName;
        if (examDetail.examItemList && Array.isArray(examDetail.examItemList)) {
          examDetail.examItemList.forEach(examInfo => {
            // 檢查是否有方案內檢項
            const packageExam = this.examInfoListUnderPackage.find(
              (item: ExamInfo) => item.examItem === examInfo.examItem
            );
            
            examInfo.deptName = deptName;
            
            // 如果在方案內,根據方案資訊設定 isNecessary 和 isChoice
            if (packageExam) {
              examInfo.isNecessary = packageExam.examType === this.examTypeText[0];
              examInfo.isChoice = packageExam.selectFlag === 1;
            } else {
              // 如果不在方案內,保持 API 原本的值
              examInfo.isNecessary = examInfo.isNecessary ?? false;
              examInfo.isChoice = examInfo.isChoice ?? false;
            }
            
            this.examInfoList.push(examInfo);
          });
        }
      });

    }else{
      //一般預約流程
      examDetailList.forEach(examDetail => {
        const deptName = examDetail.deptName;
        if (examDetail.examItemList && Array.isArray(examDetail.examItemList)) {
          examDetail.examItemList.forEach(examInfo => {
            examInfo.deptName = deptName;
            this.examInfoList.push(examInfo);
          });
        }
      });
    }

    // 快速搜索
    this.quickSearchText = '';
    // 設置快速搜索類別
    this.quickSearchDeptNames = []; // 避免每次都加入同批examDetail.deptName

    const deptNameSet = new Set<string>();

    // 先加入 熱門檢項
    const hotExamName = this.translateService.instant('reserve-add.popular-deptName');
    if (this.hotExamDetail && this.hotExamDetail.length > 0) {
      const hasVisibleHotExam = this.hotExamDetail.some(examDetail => 
        examDetail.examItemList?.some(examInfo => 
          examInfo.price && Number(examInfo.price) > 0
        )
      );
      if (hasVisibleHotExam) {
        deptNameSet.add(hotExamName);
      }
    }
    
    this.allExamDetail.forEach(examDetailArray => {
      if (examDetailArray && Array.isArray(examDetailArray)) {
        examDetailArray.forEach(examDetail => {
          if (examDetail.deptName && examDetail.examItemList) {
            // 檢查該分類下是否有任何可見的檢項
            const hasVisibleExam = examDetail.examItemList.some(examInfo => {
              // 檢查是否為方案內檢項
              const packageExam = this.examInfoListUnderPackage.find(
                (item: ExamInfo) => item.examItem === examInfo.examItem
              );

              if (packageExam) {
                // 從會員中心調整檢項:過濾所有方案內檢項
                if (this.searchType === 0) {
                  console.log("我從會員中心來，過濾方案內檢項:", packageExam.examItem);
                  return false;
                }
                
                // 個人預約:判斷是否為必檢且已選
                if (this.sharedStorageService.get('reserveType') === '1') {
                  const isNecessary = packageExam.examType === this.examTypeText[0];
                  const isChoice = packageExam.selectFlag === 1;
                  if (isNecessary && isChoice) {
                    return false;
                  }
                } 
                // 企業預約:過濾所有方案內檢項
                else if (this.sharedStorageService.get('reserveType') === '2') {
                  return false;
                }
              }
              
              // 檢查是否與方案內檢項互斥
              const hasMutexWithPackageItem = examInfo.mutexInfos?.some(mutexItem => 
                this.examInfoListUnderPackage.some(
                  (item: ExamInfo) => item.examItem === mutexItem
                )
              ) ?? false;
              
              if (hasMutexWithPackageItem) {
                return false;
              }
              
              // 過濾價格為0的項目
              if (!examInfo.price || Number(examInfo.price) <= 0) {
                return false;
              }
              
              return true;
            });
            
            // 只有當該分類下有可見檢項時才加入
            if (hasVisibleExam) {
              deptNameSet.add(examDetail.deptName);
            }
          }
        });
      }
    });

    this.quickSearchDeptNames = Array.from(deptNameSet);
    this.quickSearchSelectedDeptName = '';

    console.log('快速搜索 - quickSearchDeptNames:', this.quickSearchDeptNames);
  }

  // 卡片勾選/取消勾選檢項
  toggleChecked(checked: boolean, examInfo: AddExamInfo) {
    
    // 加入企業預約判斷
    // 如果是從會員中心過來，方案內的檢項都不能操作
    if (this.isFromMemberCenter && this.examInfoListUnderPackage.some(
        (item: ExamInfo) => item.examItem === examInfo.examItem
      )
    ) {
      return;
      // 如果是必選且已選中的方案內檢項，也不能取消勾選
    } else if (examInfo.isNecessary && examInfo.isChoice) {
      return;
    } else if (this.sharedStorageService.get('reserveType') === '2' && this.isExamInPackage(examInfo.examItem)) {
      return;
    }
    if (checked) {
      if (
        this.examInfoListUnderPackage.some(
          (item: ExamInfo) => item.examItem === examInfo.examItem
        )
      ) {
        // 如果已經在方案底下，則添加checkedExamItemListUnderPackage，並且不添加到checkedExamInfoList
        this.checkedExamItemListUnderPackage.push(examInfo.examItem);

        // 移除removeItemQuestionMap
        this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
          item => item.examItem !== examInfo.examItem
        );
        
        // 取得選擇的方案檢項價格(原價)
        const examPrice = this.examInfoListUnderPackage.find(
          (item: ExamInfo) => item.examItem === examInfo.examItem
        )?.examPrice;

        // 更新原始總價
        this.originalPrice = this.originalPrice.add(new Decimal(examPrice ?? 0));
        console.log("加法原始總價:", this.originalPrice.toString());

        // 更新動態折扣率和應付金額
        const discountRate = this.movedDiscountRate(this.originalPrice);
        console.log("movedDiscountRate", discountRate.toString());

        // 添加互斥檢項(已選，且在方案內)
        examInfo.mutexInfos?.forEach(mutexInfo => {
          this.mutexInfos.add(mutexInfo);
          }); 
        
        // 更新購物車
        this.refreshShoppingCart();
      } else {
        console.log("不在方案底下的加選檢項:", examInfo.examName);
        // 如果不在方案底下，則為添加檢項
        this.checkedExamInfoList.push(examInfo);
        examInfo.mutexInfos?.forEach(mutexInfo => {
          this.mutexInfos.add(mutexInfo);
        }); // 添加互斥檢項

        // 移除removeItemQuestionMap
        this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
          item => item.examItem !== examInfo.examItem
        );
        this.paymentAmount = this.paymentAmount + Number(examInfo.price);
      }
    } else {
      if (
        this.examInfoListUnderPackage.some(
          (item: ExamInfo) => item.examItem === examInfo.examItem
        )
      ) {
        // 如果已經在方案底下，則從checkedExamItemListUnderPackage中移除
        this.checkedExamItemListUnderPackage =
          this.checkedExamItemListUnderPackage.filter(
            item => item !== examInfo.examItem
          );
          const packageExamInfo = this.examInfoListUnderPackage.find(
            (item: ExamInfo) => item.examItem === examInfo.examItem
          );

          // 刪除互斥檢項(未選，且在方案內)
          examInfo.mutexInfos?.forEach(mutexInfo => {
            const isSharedByOtherCheckedItems = this.isSharedMutexInfo(mutexInfo, examInfo.examItem);
            if (!isSharedByOtherCheckedItems) {
              this.mutexInfos.delete(mutexInfo);
            }
          }); 
        

          // 將移除的方案檢項加入removeItemQuestionMap
          if (packageExamInfo && !this.removeItemQuestionMap.some(item => item.examItem === packageExamInfo.examItem)) {
            this.removeItemQuestionMap.push(packageExamInfo);
          }

          // 取得該方案檢項原始售價
          const examPrice = packageExamInfo?.examPrice;
          console.log("移除前 originalPrice:", this.originalPrice.toString());
          console.log("移除前 paymentAmount:", this.paymentAmount);
          console.log("移除檢項價格:", examPrice);

          // 移除後只需要更新 originalPrice，金額計算交給 refreshShoppingCart
          this.originalPrice = this.originalPrice.sub(new Decimal(examPrice ?? 0));
          console.log("移除後 originalPrice:", this.originalPrice.toString());

      } else {
        this.checkedExamInfoList = this.checkedExamInfoList.filter(
          item => item.examItem !== examInfo.examItem
        );
        examInfo.mutexInfos?.forEach(mutexInfo => {
          const isSharedByOtherCheckedItems = this.isSharedMutexInfo(mutexInfo, examInfo.examItem);
          if (!isSharedByOtherCheckedItems) {
            this.mutexInfos.delete(mutexInfo);
          }
        }); // 刪除互斥檢項
        this.paymentAmount = this.paymentAmount - Number(examInfo.price);

        // 更新購物車
        this.refreshShoppingCart();
      }
    }
    this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);

    // 更新購物車
    this.refreshShoppingCart();
  }

  // 購物車勾選/取消勾選檢項(個人方案底下檢項)
  toggleCheckedUnderPackage(checked: boolean, examInfo: ExamInfo) {
    console.log('toggleCheckedUnderPackage:', checked, examInfo);
    if (checked) {
      // 如果不在方案內清單中，才加入勾選清單，以防重複
      if (!this.checkedExamItemListUnderPackage.includes(examInfo.examItem)) {
        this.checkedExamItemListUnderPackage.push(examInfo.examItem);
      }
      
      // 從移除清單中移除
      this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
        item => item.examItem !== examInfo.examItem
      );

      // 更新原始總價
      const examPrice = examInfo.examPrice;
      this.originalPrice = this.originalPrice.add(new Decimal(examPrice ?? 0));

      // 從 examInfoList 中找到對應的檢項來取得 mutexInfos
      let addExamInfo = this.examInfoList.find(
        item => item.examItem === examInfo.examItem
      );

      if (!addExamInfo && this.allExamDetail) {
        const mutexInfosToAdd: string[] = [];
        
        // 遍歷所有檢項，找出 mutexInfos 中包含當前檢項的項目
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            examDetail.examItemList?.forEach(item => {
              if (item.mutexInfos?.includes(examInfo.examItem)) {
                // 如果其他檢項的 mutexInfos 包含當前檢項，
                // 表示當前檢項被勾選時，該檢項應該變成不可選
                mutexInfosToAdd.push(item.examItem);
              }
            });
          }
        }
        mutexInfosToAdd.forEach(mutexInfo => {
          this.mutexInfos.add(mutexInfo);
        });
        console.log('反向查找到的互斥檢項:', mutexInfosToAdd);
      }

      console.log("新增互斥檢項:", addExamInfo?.mutexInfos);

      // 添加互斥檢項
      addExamInfo?.mutexInfos?.forEach(mutexInfo => {
        this.mutexInfos.add(mutexInfo);
      });

      this.refreshShoppingCart();
    } else {
      this.checkedExamItemListUnderPackage =
        this.checkedExamItemListUnderPackage.filter(
          item => item !== examInfo.examItem
        );

      // 將移除的方案檢項加入removeItemQuestionMap
      if (!this.removeItemQuestionMap.some(item => item.examItem === examInfo.examItem)) {
        this.removeItemQuestionMap.push(examInfo);
      }

      const examPrice = examInfo.examPrice;

      // 更新原始總價
      this.originalPrice = this.originalPrice.sub(new Decimal(examPrice ?? 0));

      // 從 examInfoList 中找到對應的檢項來取得 mutexInfos
      let addExamInfo = this.examInfoList.find(
        item => item.examItem === examInfo.examItem
      ); 

      if (!addExamInfo && this.allExamDetail) {
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            const foundExamInfo = examDetail.examItemList?.find(
              item => item.examItem === examInfo.examItem
            );
            console.log("allExamDetail找到的foundExamInfo:", foundExamInfo);
            if (foundExamInfo) {
              addExamInfo = foundExamInfo;
              break;
            }
          }
          if (addExamInfo) break;
        }
      }

      // 如果找不到該檢項的 mutexInfos，則反向查找
      if (!addExamInfo && this.allExamDetail) {
        const mutexInfosToRemove: string[] = [];
        
        // 遍歷所有檢項，找出 mutexInfos 中包含當前檢項的項目
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            examDetail.examItemList?.forEach(item => {
              if (item.mutexInfos?.includes(examInfo.examItem)) {
                // 如果其他檢項的 mutexInfos 包含當前檢項，
                // 表示當前檢項被移除時，該檢項應該可以被選擇
                mutexInfosToRemove.push(item.examItem);
              }
            });
          }
        }
        
        console.log('反向查找到的互斥檢項:', mutexInfosToRemove);
        
        // 移除這些互斥檢項（如果沒有被其他已勾選檢項共享）
        mutexInfosToRemove.forEach(mutexInfo => {
          const isSharedByOtherCheckedItems = this.isSharedMutexInfo(mutexInfo, examInfo.examItem);
          if (!isSharedByOtherCheckedItems) {
            this.mutexInfos.delete(mutexInfo);
            console.log('移除互斥檢項:', mutexInfo);
          }
        });
      }

      // 如果找到該檢項的 mutexInfos
      addExamInfo?.mutexInfos?.forEach(mutexInfo => {
        console.log('刪除互斥檢項:', mutexInfo);
        // 檢查是否被其他已勾選檢項共享互斥檢項
        const isSharedByOtherCheckedItems = this.isSharedMutexInfo(mutexInfo, examInfo.examItem);
        if (!isSharedByOtherCheckedItems) {
          this.mutexInfos.delete(mutexInfo);
        }
      });
      // 更新購物車
      this.refreshShoppingCart();
    }
    
    this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
  }

  //若方案內升級項目被移除，須補回原優先必要檢查項目(個人)
  OnChangeToRequiredItems(): Observable<boolean> {
    const addAnesthesiaValue = this.addAnesthesia;
    
    // 等待麻醉判斷，先不發 API
    if (addAnesthesiaValue === undefined) {
      return of(false); // 或者回傳適當的值
    }

    const requiredItemsRequest: RequiredItemsRequest = {
      orgNo: this.sharedStorageService.get('userPlanRequest')?.orgNo ?? '',
      idNo: this.sharedStorageService.get('userPlanRequest')?.idNo ?? '',
      callStage: 0, // 加選時固定帶 0
      anesConsent: addAnesthesiaValue,
      examItemList: this.examInfoListUnderPackage
        .filter((examInfo: ExamInfo) => examInfo.selectFlag === 1)
        .map((examInfo: ExamInfo) => ({
          examItem: examInfo.examItem,
          examName: examInfo.examName,
          selectFlag: 1,
        })),
      addList: this.checkedExamInfoList.map(examInfo => ({
        examItem: examInfo.examItem,
        examName: examInfo.examName,
      })),
    };

    return this.reserveAddService.requiredItems(requiredItemsRequest).pipe(
      map(res => {
        // 檢查 res 是否為 null 或 undefined
        if (!res || !res.data) {
          console.warn('API 回應為空或缺少 data 屬性:', res);
          return false;
        }
        
        const reserveType = this.sharedStorageService.get('reserveType');
        const changeList = res.data.changeList ?? [];
        const addAnesthesiaExamItem = res.data.addAnesList ?? [];
        const removeAnesthesiaExamItem = res.data.removeAnesList ?? [];
        const removeList = res.data.removeList ?? [];


        // const changeItemName = res.data.changeList
        //   ?.map((item: ChangeItem) => item.examItemList?.map((exam: ExamItemInfo) => exam.examName).join('、'))
        //   .join('、');
        // const removeItemName = res.data.removeList?.map(item => item.examName).join('、') ?? '';
        
        // 追蹤是否有任何變更需要重新計算
        let needRecalculate = false;

        console.log('API 回應 - changeList:', changeList);
        console.log('API 回應 - removeList:', removeList);
        console.log('API 回應 - addAnesthesiaExamItem:', addAnesthesiaExamItem);
        console.log('API 回應 - removeAnesthesiaExamItem:', removeAnesthesiaExamItem);

        const modifyType = this.sharedStorageService.get('modifyType');

        // 處理換項清單 (個人預約專用)
        if (changeList && changeList.length > 0 && reserveType === '1' && modifyType !== 'modifyExam') {
          console.log('有項目要換:', changeList);
          changeList.forEach((item: ChangeItem) => {
            if (item.examItemList && item.examItemList.length > 0) {
              item.examItemList.forEach((examItem: ExamItemInfo) => {
                // 先檢查是否已存在於方案中
                const existingExam = this.examInfoListUnderPackage.find(
                  (existingItem: ExamInfo) => existingItem.examItem === examItem.examItem
                );

                if (existingExam) {
                  // 已存在,更新 selectFlag
                  const previousSelectFlag = existingExam.selectFlag;
                  existingExam.selectFlag = 1; // API 要求加回,設為 1
                  
                  console.log(`檢項已存在,更新 selectFlag: ${examItem.examName} (${previousSelectFlag} → 1)`);
                  
                  // 加入勾選清單
                  if (!this.checkedExamItemListUnderPackage.includes(examItem.examItem)) {
                    this.checkedExamItemListUnderPackage.push(examItem.examItem);
                    console.log('加入勾選清單:', examItem.examItem);
                  }
                  
                  // 從移除清單中移除
                  this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
                    removedItem => removedItem.examItem !== examItem.examItem
                  );
                  
                  needRecalculate = true;
                } else {
                  // 不存在,新增到方案中
                  const newExamInfo: ExamInfo = {
                    examName: examItem.examName ?? '',
                    examItem: examItem.examItem,
                    examPrice: examItem.price ?? '0',
                    examMemo: examItem.examMemo ?? '',
                    examType: this.examTypeText[0],
                    deptName: item.deptName,
                    rateStatus: examItem.rateStatus,
                    selectFlag: 1,
                  };

                  // 先加入勾選清單
                  if (!this.checkedExamItemListUnderPackage.includes(examItem.examItem)) {
                    this.checkedExamItemListUnderPackage.push(examItem.examItem);
                    console.log('加入勾選清單:', examItem.examItem);
                  }
                  
                  // 再加入方案清單
                  this.examInfoListUnderPackage.push(newExamInfo);
                  needRecalculate = true;
                  console.log('換項加入方案:', examItem.examName, examItem.examItem);
                }
              });
            }
          });

          console.log('處理完 changeList 後的 checkedExamItemListUnderPackage:', this.checkedExamItemListUnderPackage);
          console.log('處理完 changeList 後的 examInfoListUnderPackage:', this.examInfoListUnderPackage);
        }

        // 處理單純移除清單
        if (removeList && removeList.length > 0 && reserveType === '1' && modifyType !== 'modifyExam') {
          console.log("有項目要移除 :", removeList);

          removeList.forEach(removeItem => {
            const existsInPackage = this.examInfoListUnderPackage.some(
              (existingItem: ExamInfo) => existingItem.examItem === removeItem.removeExamItem
            );

            if (existsInPackage) {
              this.checkedExamItemListUnderPackage = this.checkedExamItemListUnderPackage.filter(
                item => item !== removeItem.removeExamItem
              );
              console.log("從方案勾選清單中移除項目:", removeItem.removeExamName);

              const packageExamInfo = this.examInfoListUnderPackage.find(
                (item: ExamInfo) => item.examItem === removeItem.removeExamItem
              );
              
              if (packageExamInfo && !this.removeItemQuestionMap.some(item => item.examItem === packageExamInfo.examItem)) {
                this.removeItemQuestionMap.push(packageExamInfo);
              }
              needRecalculate = true;
            } else {
              this.checkedExamInfoList = this.checkedExamInfoList.filter(
                item => item.examItem !== removeItem.removeExamItem
              );
              console.log("從加選清單移除項目:", removeItem.removeExamName);
              needRecalculate = true;
            }
          });
        }

        // 統一顯示 dialog (只在有 changeList 或 removeList 時顯示一次)
        if ((changeList && changeList.length > 0) || (removeList && removeList.length > 0) && reserveType === '1' && modifyType !== 'modifyExam') {
          // 顯示 dialog
          const dialog = this.dialog.open(ChangeExamItemDialogComponent, {
            data: {
              addedItems: res.data?.changeList?.flatMap((change: ChangeItem) => 
                change.examItemList?.map((exam: ExamItemInfo) => exam.examName) || []
              ) || [],
              removedItems: res.data?.removeList?.map((item: RemoveItem) => ({
              examName: item.removeExamName,        // 被移除的必檢檢項名稱
              includedExamName: item.upgradeExamName // 升級的檢項名稱
              })) || [],
              buttonText: this.translateService.instant('common.button.i-understood'),
              showCloseButton: false,
              action: () => {
                dialog.close();
              },
            },
          });
        }

        // 處理新增麻醉項目
        if (addAnesthesiaExamItem && addAnesthesiaExamItem.length > 0) {
          console.log("有麻醉項目要加 :", addAnesthesiaExamItem);
          
          addAnesthesiaExamItem.forEach(addItem => {
            const newExamInfo: AddExamInfo = {
              examName: addItem?.examName ?? '',
              examItem: addItem.examItem,
              examMemo: addItem.examMemo ?? '',
              price: addItem.price ?? '0',
              mutexInfos: [],
              isNecessary: false,
              isChoice: true,
              disable: false,
              examType: '',
              deptName: '',
              deptEName: '',
            };

            const existsInPackage = this.examInfoListUnderPackage.some(
              (existingItem: ExamInfo) => existingItem.examItem === addItem.examItem
            );
            
            const existsInAdded = this.checkedExamInfoList.some(
              (existingItem: AddExamInfo) => existingItem.examItem === addItem.examItem
            );
            
            if (!existsInPackage && !existsInAdded) {
              console.log("加選麻醉項目: ", addItem.examName);
              this.checkedExamInfoList.push(newExamInfo);
              needRecalculate = true;
            }
          });
        }

        // 處理移除麻醉項目
        if (removeAnesthesiaExamItem && removeAnesthesiaExamItem.length > 0) {
          console.log("有麻醉項目要移除 :", removeAnesthesiaExamItem);

          removeAnesthesiaExamItem.forEach(removeItem => {
            const existsInPackage = this.examInfoListUnderPackage.some(
              (existingItem: ExamInfo) => existingItem.examItem === removeItem.examItem
            );

            if (existsInPackage) {
              this.checkedExamItemListUnderPackage = this.checkedExamItemListUnderPackage.filter(
                item => item !== removeItem.examItem
              );
              console.log("從方案勾選清單中移除麻醉項目:", removeItem.examName);

              const packageExamInfo = this.examInfoListUnderPackage.find(
                (item: ExamInfo) => item.examItem === removeItem.examItem
              );
              
              if (packageExamInfo && !this.removeItemQuestionMap.some(item => item.examItem === packageExamInfo.examItem)) {
                this.removeItemQuestionMap.push(packageExamInfo);
              }
              needRecalculate = true;
            } else {
              this.checkedExamInfoList = this.checkedExamInfoList.filter(
                item => item.examItem !== removeItem.examItem
              );
              console.log("從加選清單移除麻醉項目:", removeItem.examName);
              needRecalculate = true;
            }
          });
        }

        // 統一重新計算(只在有變更時執行)
        if (needRecalculate) {
          console.log("開始統一重新計算金額...");
          
          // 重新計算原始總價
          this.originalPrice = this.examInfoListUnderPackage
            .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
            .reduce((total, examInfo) => {
              return total.add(new Decimal(examInfo.examPrice ?? 0));
            }, new Decimal(0));
          
          console.log("重新計算後的 originalPrice:", this.originalPrice.toString());

          // 更新 examItemList 的 selectFlag
          const examItemList = this.examInfoListUnderPackage.map(
            (examInfo: ExamInfo) => {
              examInfo.selectFlag = this.checkedExamItemListUnderPackage.includes(examInfo.examItem) ? 1 : 0;
              return examInfo;
            }
          );

          // 計算折扣後的方案金額
          const discountedPackagePrice = this.examInfoListUnderPackage
            .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
            .reduce((total, examInfo) => {
              const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
              
              if (examInfo.rateStatus === true) {
                let discountedPrice = originalPrice.mul(this.movedDiscountRate(this.originalPrice));
                let roundedPrice = discountedPrice.div(10).ceil().mul(10);
                
                if (this.partyDiscountRate) {
                  roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                  roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
                }
                return total + roundedPrice.toNumber();
              } else {
                return total + originalPrice.toNumber();
              }
            }, 0);

          console.log("重新計算後的 discountedPackagePrice:", discountedPackagePrice);

          // 更新 storage
          this.sharedStorageService.set('originalPrice', discountedPackagePrice);
          this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
          this.sharedStorageService.set('examItemList', examItemList);
          this.sharedStorageService.set('addExamItemList', this.checkedExamInfoList);
          
          // 刷新購物車
          this.refreshShoppingCart();
        }

        return true; // 成功時返回 true
      })
    );
  }

  // 更新購物車
  refreshShoppingCart() {
    // 企業預約
    // 統一 deptName 格式的函數
    const normalizeDeptName = (deptName: string): string => {
      return deptName.replace(/\([^)]*\)/g, '').trim();
    }
    this.examInfoListUnderPackage = this.examInfoListUnderPackage.map(
      (examInfo: ExamInfo) => {
        examInfo.selectFlag = this.checkedExamItemListUnderPackage.includes(examInfo.examItem) ? 1 : 0;
        return examInfo;
      }
    );

    // 企業預約的購物車更新
    this.examInfoListUnderPackageByType = this.examInfoListUnderPackage
      .filter((examInfo: ExamInfo) => {
        if (examInfo.selectFlag === 1) return true;
        if (examInfo.selectFlag === 0 && !examInfo.isNecessary) return true;
        return false;
      })
      .reduce((typeMap, examInfo) => {
        const type = examInfo.examType ?? 'unknown';
        const dept = normalizeDeptName(examInfo.deptName ?? 'unknown');
        if (!typeMap.has(type)) {
          typeMap.set(type, new Map<string, ExamInfo[]>());
        }
        const deptMap = typeMap.get(type)!;
        if (!deptMap.has(dept)) {
          deptMap.set(dept, []);
        }
        deptMap.get(dept)!.push(examInfo);
        return typeMap;
      }, new Map<string, Map<string, ExamInfo[]>>()
    );

    console.log('refreshShoppingCart - 購物車已更新,只包含 selectFlag = 1 的檢項');

    // 判斷：若方案內有雙項麻醉DAn，且加選有SAn，則將方案內的麻醉DAn反灰不給選擇
    const danExamItem = this.getAnesthesiaExamItem('dAn');
    const sanExamItem = this.getAnesthesiaExamItem('sAn');

    // 檢查方案內是否有雙項麻醉
    const packageHasDAn = danExamItem && danExamItem.some(danItem =>
      this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)
    );

    // 檢查加選是否有單項麻醉
    const addedHasSAn = sanExamItem && sanExamItem.some(sanItem =>
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === sanItem)
    );

    // 檢查加選是否有雙項麻醉
    const addedHasDAn = danExamItem && danExamItem.some(danItem =>
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === danItem)
    );

    // 根據企業還是個人，取得相對應的 giInfo
    const isEnterprise = this.sharedStorageService.get('reserveType') === '2';
    const giInfo = isEnterprise ? this.checkSuggestionsEnterpriseResponse?.giInfo : this.checkSuggestionsResponse?.giInfo;

    // 方案內是否有腸鏡
    const packageHasScs = this.checkedExamItemListUnderPackage.some(examItem => 
      giInfo?.scs?.includes(examItem)
    );

    // 方案內是否有胃鏡
    const packageHasSgs = this.checkedExamItemListUnderPackage.some(examItem => 
      giInfo?.sgs?.includes(examItem)
    );

    // 若方案內有DAn且加選有SAn，則將方案內的DAn加入互斥檢項（反灰）
    if (packageHasDAn && addedHasSAn && danExamItem) {
      danExamItem.forEach(danItem => {
        // 只有當該DAn在方案內時才加入互斥
        if (this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)) {
          this.mutexInfos.add(danItem);
          console.log('refreshShoppingCart - 因加選有SAn，將方案內的DAn反灰:', danItem);
        }
      });
    } else if (packageHasDAn && !addedHasSAn && danExamItem) {
      // 若加選沒有SAn，則移除DAn的互斥狀態（如果之前被加入的話）
      danExamItem.forEach(danItem => {
        if (this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)) {
          // 檢查是否被其他已勾選檢項共享互斥檢項
          const isSharedByOtherCheckedItems = this.isSharedMutexInfo(danItem, '');
          if (!isSharedByOtherCheckedItems) {
            this.mutexInfos.delete(danItem);
            console.log('refreshShoppingCart - 因加選沒有SAn，移除方案內DAn的反灰:', danItem);
          }
        }
      });
    }
    // 若加選有SAn或DAn，則需要遍歷allExamDetail，將與SAn或DAn互斥的檢項加入mutexInfos 
    else if (addedHasSAn || addedHasDAn) {
      if (this.allExamDetail) {
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            examDetail.examItemList?.forEach(examInfo => {
              // 檢查該檢項的 mutexInfos 是否包含已加選的 SAn 或 DAn
              if (examInfo.mutexInfos && examInfo.mutexInfos.length > 0) {
                const hasMutexWithAddedAnesthesia = examInfo.mutexInfos.some(mutexItem => {
                  return (addedHasSAn && sanExamItem?.includes(mutexItem)) || 
                          (addedHasDAn && danExamItem?.includes(mutexItem));
                });
                
                if (hasMutexWithAddedAnesthesia) {
                  this.mutexInfos.add(examInfo.examItem);
                  console.log('refreshShoppingCart - 因加選有SAn或DAn，將與之互斥的檢項反灰:', examInfo.examName, examInfo.examItem);
                }
              }
            });
          }
        }
      }
    } else {
      // 若加選沒有SAn或DAn，則移除之前因麻醉而加入的互斥項目
      if (this.allExamDetail && sanExamItem && danExamItem) {
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            examDetail.examItemList?.forEach(examInfo => {
              if (examInfo.mutexInfos && examInfo.mutexInfos.length > 0) {
                const hasMutexWithAnesthesia = examInfo.mutexInfos.some(mutexItem => {
                  return sanExamItem.includes(mutexItem) || danExamItem.includes(mutexItem);
                });
                
                if (hasMutexWithAnesthesia) {
                  // 檢查是否被其他已勾選檢項共享
                  const isSharedByOtherCheckedItems = this.isSharedMutexInfo(examInfo.examItem, '');
                  if (!isSharedByOtherCheckedItems) {
                    this.mutexInfos.delete(examInfo.examItem);
                    console.log('refreshShoppingCart - 因加選沒有SAn或DAn，移除之前的反灰:', examInfo.examName, examInfo.examItem);
                  }
                }
              }
            });
          }
        }
      }
    }

    // 根據方案內是否同時有腸鏡與胃鏡，決定雙項麻醉勾選狀態
    if (danExamItem) {
      danExamItem.forEach(danItem => {
        if (this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem)) {
          // 方案內有DAn且方案內同時有腸鏡與胃鏡，則可以勾選雙項麻醉
          // if (packageHasScs && packageHasSgs && !addedHasSAn) {
          //   const isSharedByOtherCheckedItems = this.isSharedMutexInfo(danItem, '');

          //   if (!isSharedByOtherCheckedItems) {
          //     this.checkedExamItemListUnderPackage = [...this.checkedExamItemListUnderPackage, danItem];
          //     this.mutexInfos.delete(danItem);
          //     console.log('refreshShoppingCart - 因方案內有腸鏡與胃鏡，移除方案內DAn的反灰:', danItem);
          //   }

          // } 
          if (!packageHasScs || !packageHasSgs) {
            this.checkedExamItemListUnderPackage = this.checkedExamItemListUnderPackage.filter(item => item !== danItem);
            this.mutexInfos.add(danItem);
            this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
            console.log('refreshShoppingCart - 因方案內沒有腸鏡與胃鏡，將方案內DAn反灰:', danItem);
          }

          // 重新計算原始總價
          this.originalPrice = this.examInfoListUnderPackage
            .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
            .reduce((total, examInfo) => {
              return total.add(new Decimal(examInfo.examPrice ?? 0));
            }, new Decimal(0));

          // 重新計算折扣後的方案金額
          const discountedPackagePrice = this.examInfoListUnderPackage
            .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
            .reduce((total, examInfo) => {
              const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
              if (examInfo.rateStatus === true) {
                let discountedPrice = originalPrice.mul(this.movedDiscountRate(this.originalPrice));
                let roundedPrice = discountedPrice.div(10).ceil().mul(10);
                if (this.partyDiscountRate) {
                  roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                  roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
                }
                return total + roundedPrice.toNumber();
              } else {
                return total + originalPrice.toNumber();
              }
            }, 0);

          this.sharedStorageService.set('originalPrice', discountedPackagePrice);
        }
      })
    }
    
    console.log('更新後的 mutexInfos:', Array.from(this.mutexInfos));

    console.log('更新購物車後的examInfoListUnderPackage:', this.checkedExamItemListUnderPackage);
    console.log('removeItemQuestionMap:', this.removeItemQuestionMap);

    if (this.sharedStorageService.get('reserveType') === '1') {
      this.examInfoListUnderPackageByType =
        this.examInfoListUnderPackage
          .reduce((typeMap, examInfo) => {
            const type = examInfo.examType ?? 'unknown';
            const dept = examInfo.deptName ?? 'unknown';
            if (!typeMap.has(type)) {
              typeMap.set(type, new Map<string, ExamInfo[]>());
            }
            const deptMap = typeMap.get(type)!;
            if (!deptMap.has(dept)) {
              deptMap.set(dept, []);
            }
            deptMap.get(dept)!.push(examInfo);
            return typeMap;
          }, new Map<string, Map<string, ExamInfo[]>>());

    
      // 重新計算金額
      const discountRate = this.movedDiscountRate(this.originalPrice);
      const originalExamItemList = this.sharedStorageService.get('originalExamItemList');
    
      this.paymentAmount = this.examInfoListUnderPackage
        .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
        .reduce((total, examInfo) => {
          // 優先從 originalExamItemList 取得原始價格
          let originalPrice = new Decimal(0);
          if (originalExamItemList && originalExamItemList.length > 0) {
            const originalExamInfo = originalExamItemList.find(item => item.examItem === examInfo.examItem);
            originalPrice = new Decimal(originalExamInfo?.examPrice ?? examInfo.examPrice ?? 0);
          } else {
            originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
          }
          
          if (examInfo.rateStatus === true) {
            let discountedPrice = originalPrice.mul(discountRate);
            let roundedPrice = discountedPrice.div(10).ceil().mul(10);
            // 若有活動折扣率
            if (this.partyDiscountRate) {
              roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
              // 四捨五入到個位整數
              roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
            }
            return total + roundedPrice.toNumber();
          } else {
            console.log("加原價:",examInfo.examName,"rateStatus:",examInfo.rateStatus);
            return total + originalPrice.toNumber();
          }
        }, 0);
    
      const addExamPrice = this.checkedExamInfoList.reduce((total, item) => {
        return total + (Number(item.price) || 0);
      }, 0);
      this.paymentAmount += addExamPrice;
      this.examInfoList.forEach(examInfo => {
        examInfo.disable = this.mutexInfos.has(examInfo.examItem);
      });
      console.log("refreshShoppingCart後的 paymentAmount:", this.paymentAmount);

      // 建立 aiChatbotExamItemList，包含折扣後的價格，型態與 examItemList 一致
      const aiChatbotExamItemList = this.examInfoListUnderPackage
        .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
        .map(examInfo => {
          // 計算折扣後價格
          let finalPrice = new Decimal(examInfo.examPrice ?? 0);
          
          if (examInfo.rateStatus === true) {
            let discountedPrice = finalPrice.mul(discountRate);
            let roundedPrice = discountedPrice.div(10).ceil().mul(10); // 無條件十進位
            
            // 若有活動折扣率
            if (this.partyDiscountRate) {
              roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
              roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
            }
            finalPrice = roundedPrice;
          } 
          
          return {
            ...examInfo, // 保留原有的 ExamInfo 屬性
            examPrice: finalPrice.toString() // 更新為折扣後的價格
          };
        });
      this.sharedStorageService.set('aiChatbotExamItemList', aiChatbotExamItemList);
    }
    this.sharedStorageService.set('paymentAmount', this.paymentAmount);
  }

  // 勾選/取消勾選企業方案檢項
  toggleCheckedBusinessExamInfoUnderPackage(
    checked: boolean,
    businessExamInfo: BusinessExamInfo
  ) {
    if (checked) {
      this.checkedBusinessExamInfoUnderPackage.push(businessExamInfo);
    } else {
      this.checkedBusinessExamInfoUnderPackage =
        this.checkedBusinessExamInfoUnderPackage.filter(
          item => item !== businessExamInfo
        );
    }
  }

  // 勾選/取消勾選企業方案組合檢項
  toggleCheckedBusinessGroupUnderPackage(checked: boolean, group: Group) {
    if (checked) {
      this.checkedBusinessGroupUnderPackage.push(group);
    } else {
      this.checkedBusinessGroupUnderPackage =
        this.checkedBusinessGroupUnderPackage.filter(item => item !== group);
    }
  }

  //卡牌不可取消
  // 個人方案內的標準檢查項不可取消
  // 企業方案內不可取消
  isActiveDisabled(examItem: string, examType?: string): boolean {
    const reserveType = this.sharedStorageService.get('reserveType');

    if (reserveType === ID_LOGIN_TYPE.PERSONAL) {
      return (
        this.checkedExamItemListUnderPackage.includes(examItem) &&
        examType === this.translatedStandardType
      );
    } else {
      return this.checkedBusinessExamInfoUnderPackage.some(
        item => item.examItem === examItem
      );
    }
  }

  // 切換側邊欄
  toggleCart(): void {
    console.log('toggleCart 被呼叫');
    this.isCartOpen = !this.isCartOpen;

    // 通知chatbot 購物車狀態
    this.cartStateService.setCartOpen(this.isCartOpen);
    
    const cartEl = this.reserveAddRightCart?.nativeElement;
    const leftEl = this.reserveAddLeftPage?.nativeElement;

    if (cartEl) {
      cartEl.classList.toggle('active');
      
      const body = this.renderer.selectRootElement('body', true);

      if (this.isCartOpen) {
        this.renderer.setStyle(body, 'overflow', 'hidden');
      } else {
        this.renderer.removeStyle(body, 'overflow');
      }
    }

    if (leftEl) {
      leftEl.classList.toggle('active');
    }
  }

  // 快速搜索依照名稱字串
  quickSearchWithText() {
    // 清除分類篩選
    // this.selectedDeptNames = [];
    
    // 如果查詢字串為空,則改用類別查詢(第1項類別)
    if (this.quickSearchText.trim() === '') {
      this.quickSearchSelectedDeptName = this.quickSearchDeptNames[0];
      this.selectedValue = this.quickSearchDeptNames[0];
      this.quickSearchWithDeptName(this.quickSearchSelectedDeptName);
      return;
    }
    this.quickSearchSelectedDeptName = '';
    this.examInfoList = [];

    const searchText = this.quickSearchText.trim();
    const examDetailList = this.allExamDetail[3];

    // 1. 從加選檢項中搜尋
    const addExamResults: AddExamInfo[] = [];
    examDetailList.forEach(examDetail => {
      const deptName = examDetail.deptName;
      examDetail.examItemList?.forEach(examInfo => {
        if (examInfo.examName?.includes(searchText)) {
          examInfo.deptName = deptName;
          addExamResults.push(examInfo);
        }
      });
    });

    // 2. 從方案內檢項中搜尋
    const packageResults: AddExamInfo[] = [];
    const packageExams = this.examInfoListUnderPackage.filter(
      examInfo => examInfo.examName?.includes(searchText)
    );
    
    packageExams.forEach(examInfo => {
      const addExamInfo: AddExamInfo = {
        examItem: examInfo.examItem,
        examName: examInfo.examName,
        examMemo: examInfo.examMemo,
        price: examInfo.examPrice,
        deptName: examInfo.deptName || '0',
        examType: examInfo.examType || '0',
        mutexInfos: [],
        isNecessary: examInfo.examType ? examInfo.examType === this.examTypeText[0] : true,
        isChoice: examInfo.examType === this.examTypeText[0]
          ? true
          : this.checkedExamItemListUnderPackage.includes(examInfo.examItem),
        disable: examInfo.examType === this.examTypeText[0],
      };
      packageResults.push(addExamInfo);
    });

    // 3. 合併並去重
    const allResults = [...packageResults, ...addExamResults];
    const uniqueResults = new Map<string, AddExamInfo>();
    allResults.forEach(exam => {
      uniqueResults.set(exam.examItem, exam);
    });

    this.examInfoList = Array.from(uniqueResults.values());
    
    // 4. 自動設定分類篩選為第一個有結果的分類
    if (this.examInfoList.length > 0) {
      const firstDeptName = this.examInfoList[0].deptName;
      if (firstDeptName) {
        this.quickSearchSelectedDeptName = firstDeptName;
        this.selectedValue = firstDeptName;
      } else {
        this.selectedValue = null;
      }
    } else {
      this.selectedValue = null;
    }
    
    console.log(`搜尋"${searchText}": 方案${packageResults.length}個, 加選${addExamResults.length}個, 合併後${this.examInfoList.length}個`);
  }

  // 快速搜索依照類別查詢
  quickSearchWithDeptName(deptName: string) {
    this.quickSearchText = ''; // 清空查詢字串
    this.quickSearchSelectedDeptName = deptName;
    this.examInfoList = [];

    const popularExamTranslation = this.translateService.instant(
      'reserve-add.dept-name.popular-examinations'
    );
    console.log('搜尋類別:', deptName);

    if (deptName === popularExamTranslation) {
      // 處理熱門檢項
      console.log('hotExamDetail:', this.hotExamDetail);

      if(this.planType === '0'){
        //從會員中心來調整檢項的
        this.hotExamDetail.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          //檢查是否有方案內檢項
          const exist = this.examInfoListUnderPackage.find(
            (item: ExamInfo) => item.examItem === examInfo.examItem
          );
          examInfo.deptName = deptName;
          examInfo.isNecessary = exist?true:false;//是方案內選項則不能退選
          this.examInfoList.push(examInfo);
        });
        console.log("熱門檢項examInfoList:",this.examInfoList)
        
      });
      }else{
        //一般預約流程
        this.hotExamDetail.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          examInfo.deptName = deptName;
          this.examInfoList.push(examInfo);
        });
      });
      }
      
    } else {
      // 加選選項
      const addExamResults: AddExamInfo[] = [];
      const examDetailList = this.allExamDetail[3];
      console.log("examDetailList:",examDetailList);

      examDetailList.forEach(examDetail => {
        if (examDetail.deptName === deptName) {
          examDetail.examItemList?.forEach(examInfo => {
            examInfo.deptName = deptName;
            addExamResults.push(examInfo);
          });
        }
      });

      const packageResults: AddExamInfo[] = [];
      const packageExamsForDept = this.examInfoListUnderPackage.filter(
        examInfo => examInfo.deptName === deptName
      );
      packageExamsForDept.forEach(examInfo => {
        const addExamInfo: AddExamInfo = {
          examItem: examInfo.examItem,
          examName: examInfo.examName,
          examMemo: examInfo.examMemo,
          price: examInfo.examPrice,
          deptName: examInfo.deptName || '0',
          examType: examInfo.examType || '0',
          mutexInfos: [],

          isNecessary: examInfo.examType ?examInfo.examType === this.examTypeText[0] : true ,//從會員中心來的會沒有examType(預設isNecessary=true)
          isChoice:
            examInfo.examType === this.examTypeText[0]
              ? true
              : this.checkedExamItemListUnderPackage.includes(
                  examInfo.examItem
                ),
          disable: examInfo.examType === this.examTypeText[0],
        };
        packageResults.push(addExamInfo);
      });

      const allResults = [...packageResults, ...addExamResults];
      const uniqueResults = new Map<string, AddExamInfo>();
      allResults.forEach(exam => {
        uniqueResults.set(exam.examItem, exam);
      });

      this.examInfoList = Array.from(uniqueResults.values());
      console.log(
        `檢項: 方案${packageResults.length}個, 加選${addExamResults.length}個, 合併後${this.examInfoList.length}個`
      );
    }

    console.log('快速搜索結果項目數量:', this.examInfoList.length);
  }

  // 顯示檢項dialog
  showExamDialog(examInfo: ExamInfo | AddExamInfo | BusinessExamInfo) {
    const examDialog = this.dialog.open(SingleActionDialogComponent, {
      data: {
        title: examInfo.examName,
        message: examInfo.examMemo,
        buttonText: this.translateService.instant('common.button.i-understood'),
        showCloseButton: false,
        action: () => examDialog.close(),
      },
    });
  }

  // 顯示組合檢項dialog
  showGroupDialog(group: Group) {
    const examDialog = this.dialog.open(SingleActionDialogComponent, {
      data: {
        title: group.groupName,
        message: group.groupMemo,
        buttonText: this.translateService.instant('common.button.i-understood'),
        showCloseButton: false,
        action: () => examDialog.close(),
      },
    });
  }

  // 勾選的檢查項目ID(加選檢項)Set
  get checkedExamItemSet(): Set<string> {
    return new Set(this.checkedExamInfoList.map(item => item.examItem));
  }

  // 企業方案deptName列表
  get businessDeptNames(): Array<string> {
    return (
      this.sharedStorageService
        .get('businessSelectedPackage')
        ?.deptList.map(
          businessPackageInfo => businessPackageInfo.deptName
        ) ?? []
    );
  }

  // 重選方案
  resetPackage() {
    // 重置購物車狀態
    this.isCartOpen = false;
    this.cartStateService.setCartOpen(this.isCartOpen);

    // 清除 body 滾動限制
    document.body.style.overflow = '';
    const resetConfirmDialog = this.dialog.open(DuoActionDialogComponent, {
      data: {
        title: this.translateService.instant(
          'reserve-add.reset-package-dialog-title'
        ),
        message: this.translateService.instant(
          'reserve-add.reset-package-dialog-message'
        ),
        leftButtonText: this.translateService.instant('common.button.cancel'),
        rightButtonText: this.translateService.instant(
          'reserve-add.reset-package'
        ),
        leftButtonAction: () => resetConfirmDialog.close(),
        rightButtonAction: () => {
          resetConfirmDialog.close();
          this.sharedStorageService.remove('indicationsQuestionList');
          this.sharedStorageService.remove('invalidExamQuestionMap');
          this.sharedStorageService.remove('tempEligibilityQuestionAnswerMap');
          this.sharedStorageService.remove('tempEligibilityNonOfFollowings');
          this.sharedStorageService.remove('tempInvalidExamQuestionMap');
          this.sharedStorageService.remove('selectedPackagePlanType');
          this.sharedStorageService.remove('selectedPackage');
          this.sharedStorageService.remove('addExamItemList');
          this.sharedStorageService.remove('removeItemQuestionMap');
          this.sharedStorageService.remove('paymentAmount');
          this.sharedStorageService.remove('originalPrice');
          this.sharedStorageService.remove('mutexItems');
          this.sharedStorageService.remove('originalExamItemList');
          this.sharedStorageService.remove('aiChatbotExamItemList');
          this.sharedStorageService.remove('examItemList');
          this.sharedStorageService.remove('secondComparedPackage');
          this.sharedStorageService.remove('thirdComparedPackage');
          this.sharedStorageService.remove('businessSelectedPackage');
          this.sharedStorageService.remove('packagePrice');
          if (
            this.sharedStorageService.get('reserveType') ===
            ID_LOGIN_TYPE.PERSONAL
          ) {
            // 個人預約
            this.sharedStorageService.remove('examItemList');
            this.sharedStorageService.remove('packagePrice');
            this.router.navigate(['/healthcheck/reserve/personalplan']).then();
          } else {
            // 企業預約
            this.sharedStorageService.remove('businessSelectedPackage');
            const isFromMemberCenter: boolean = this.sharedStorageService.get('modifyType') ? true : false;
            if(isFromMemberCenter){
              // 2026.5.19經SA確認，若企業預約修改檢項時要重選方案，合適性問卷isUpdate要帶0
              this.sharedStorageService.set('isUpdate','0');
            }
            this.router.navigate(['/healthcheck/reserve/companyplan']).then();
          }
        },
        showCloseButton: false,
      },
    });
  }

  // 驗證企業修改檢項時,原套檢金額是否有超過總金額
  get isPackagePriceValid(): boolean {
    const reserveType = this.sharedStorageService.get('reserveType');
    const modifyType = this.sharedStorageService.get('modifyType');
    const billAmt = Number(this.sharedStorageService.get('paymentAmount'));
    const sponsorAmt = Number(this.sharedStorageService.get('sponsorAmt')) || 0;
    
    // 企業預約 且 調整檢項時的驗證
    if (reserveType === ID_LOGIN_TYPE.ENTERPRISE && modifyType === 'modifyExam') {
      // 計算扣除補助金額後的總金額
      const totalAmountBeforeSponsor = billAmt + sponsorAmt;
      console.log('驗證金額 - 扣除補助前的總金額:', totalAmountBeforeSponsor);
      
      // 當扣除補助後的總金額 < 0 時(補助尚餘),返回 false 觸發彈窗
      if (totalAmountBeforeSponsor < 0) {
        return true;
      }
      // 當扣除補助後的總金額 < 套檢金額時,返回 false 觸發彈窗
      if (totalAmountBeforeSponsor < this.originalPackagePrice) {
        return false;
      }
    }
    
    return true;
  }

  // 點擊下一步按鈕
  handleNextClick() {
    // 重置購物車狀態
    this.isCartOpen = false;
    this.cartStateService.setCartOpen(this.isCartOpen);

    const billAmt = Number(this.sharedStorageService.get('paymentAmount'));
    console.log('套檢金額:', this.originalPackagePrice);
    console.log('總金額:', billAmt);
    // 驗證金額dialog - 待後端開發完成
    // if (!this.isPackagePriceValid) {
    //   const priceDialog = this.dialog.open(SingleActionDialogComponent, {
    //     data: {
    //       title: this.translateService.instant('reserve-add.price-dialog-title', {
    //           originalPrice: this.originalPackagePrice.toLocaleString()
    //       }),
    //       message:
    //         this.translateService.instant('reserve-add.price-dialog-message', {
    //           originalPrice: this.originalPackagePrice.toLocaleString()
    //         }),
    //       buttonText: this.translateService.instant('reserve-add.price-dialog-button'),
    //       showCloseButton: false,
    //       action: () => {
    //         priceDialog.close();
    //       },
    //     }
    //   });
    //   return;
    // }

    // 清除 body 滾動限制
    document.body.style.overflow = '';
    this.OnChangeToRequiredItems().pipe(take(1)).subscribe(() => {
      // 個人預約邏輯
      if (this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL) {
        // 重新計算方案金額
        const originalExamItemList = this.sharedStorageService.get('originalExamItemList');

        if (originalExamItemList && originalExamItemList.length > 0) {
          // 優先使用 originalExamItemList 中的原始價格
          this.originalPrice = originalExamItemList
            .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
            .reduce((total, examInfo) => {
              return total.add(new Decimal(examInfo.examPrice ?? 0));
            }, new Decimal(0));
            console.log("使用 originalExamItemList 計算的 originalPrice:", this.originalPrice.toString());

            const discountedPackagePrice = this.examInfoListUnderPackage
          .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
          .reduce((total, examInfo) => {
            // 從 originalExamItemList 中找到對應的原始價格
            const originalExamInfo = originalExamItemList.find(item => item.examItem === examInfo.examItem);
            const originalPrice = new Decimal(originalExamInfo?.examPrice ?? examInfo.examPrice ?? 0);
            
            //檢查rateStatus，為true才套用折扣
            if (examInfo.rateStatus === true) {
              let discountedPrice = originalPrice.mul(this.movedDiscountRate(this.originalPrice));//檢項套用折扣
              let roundedPrice = discountedPrice.div(10).ceil().mul(10);//無條件10進位
              // 若有活動折扣率
              if (this.partyDiscountRate) {
                roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                // 四捨五入到個位整數
                roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
              }
              return total + roundedPrice.toNumber();
            } else {
              return total + originalPrice.toNumber();
            }
          }, 0);
        console.log("discountedPackagePrice:", discountedPackagePrice);
        this.sharedStorageService.set('originalPrice', discountedPackagePrice);
        } else {
          this.originalPrice = this.examInfoListUnderPackage
            .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
            .reduce((total, examInfo) => {
              return total.add(new Decimal(examInfo.examPrice ?? 0));
            }, new Decimal(0));
            console.log("使用 examInfoListUnderPackage 計算的 originalPrice:", this.originalPrice.toString());

            const discountedPackagePrice = this.examInfoListUnderPackage
          .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
          .reduce((total, examInfo) => {
            const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
            
            //檢查rateStatus，為true才套用折扣
            if (examInfo.rateStatus === true) {
              console.log("準備計算的方案總價:", this.originalPrice.toString());
              let discountedPrice = originalPrice.mul(this.movedDiscountRate(this.originalPrice));//檢項套用折扣
              let roundedPrice = discountedPrice.div(10).ceil().mul(10);//無條件10進位
              // 若有活動折扣率
              if (this.partyDiscountRate) {
                roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                // 四捨五入到個位整數
                roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
              }
              return total + roundedPrice.toNumber();
            } else {
              return total + originalPrice.toNumber();
            }
          }, 0);
        console.log("discountedPackagePrice:", discountedPackagePrice);
        this.sharedStorageService.set('originalPrice', discountedPackagePrice);
        }
      } else {
        // 企業預約邏輯
        const packagePrice = this.sharedStorageService.get('businessSelectedPackage')?.price ?? 0;
        this.sharedStorageService.set('packagePrice', packagePrice.toString());
      }

      const examItemList = this.examInfoListUnderPackage.map(
            (examInfo: ExamInfo) => {
              examInfo.selectFlag = this.checkedExamItemListUnderPackage.includes(examInfo.examItem) ? 1 : 0;
              return examInfo;
            }
          );
      
      this.sharedStorageService.set('examItemList', examItemList);
      this.sharedStorageService.set('mutexItems', this.mutexInfos);
      this.sharedStorageService.set('paymentAmount', this.paymentAmount);
      this.sharedStorageService.set('addExamItemList', this.checkedExamInfoList);
      this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
      console.log('準備跳轉至overview頁面，examItemList :', this.sharedStorageService.get('examItemList'));
      console.log('準備跳轉至overview的AddExamItemList:', this.checkedExamInfoList);
      this.router.navigate(['/healthcheck/reserve/overview']).then();
    
    });
    
  }

  protected readonly ID_LOGIN_TYPE = ID_LOGIN_TYPE;

  private debugExamTypes(): void {
    // 延遲確保資料載入
    const timer = setTimeout(() => {
      console.log('方案檢項的 examType:');
      const examTypes = new Map<string, number>();
      this.examInfoListUnderPackage.forEach(exam => {
        const type = exam.examType || 'undefined';
        examTypes.set(type, (examTypes.get(type) || 0) + 1);
      });
      examTypes.forEach((count, type) => {
        // 移除這行，不要再 push 到 examTypeText
        // this.examTypeText.push(type);
        console.log(`  - ${type}: ${count} 個檢項`);
      });
      clearTimeout(timer);
    }, 2000);
  }

  // 是否有個人歷史追蹤資料
  get hasAbnormalData(): boolean {
    return this.allExamDetail.length > 0 && 
          this.allExamDetail[0] && 
          this.allExamDetail[0].length > 0 && 
          this.allExamDetail[0].some(examDetail => 
            examDetail.examItemList && examDetail.examItemList.length > 0
          );
  }
  /**
   * 計算動態折扣率
   */
  movedDiscountRate(originalPrice: Decimal): Decimal {

    //取得原始售價(未折扣)
    const aiExclusivePrice = new Decimal(this.aiExclusiveOriginalPrice ?? 0);
    const basicCheckupPrice = new Decimal(this.basicCheckupOriginalPrice ?? 0);
    const allCheckupPrice = new Decimal(this.allCheckupOriginalPrice ?? 0);

    // 取得原始折扣率
    const allCheckupRate = new Decimal(this.userPlanResponse?.allCheckup.discountRate ?? 0);
    const aiExclusiveRate = new Decimal(this.userPlanResponse?.aiExclusive.discountRate ?? 0);
    const basicCheckupRate = new Decimal(this.userPlanResponse?.basicCheckup.discountRate ?? 0);
    
    // 當目前原價大於等於全方位方案價格時
    if (originalPrice.gte(allCheckupPrice)) {
      console.log("使用全方位折扣率");
      return allCheckupRate;
    } 
    // 當目前原價大於等於智能專屬方案價格時
    else if (originalPrice.gte(aiExclusivePrice)) {
      if (originalPrice.eq(aiExclusivePrice)) {
        console.log("使用智能專屬折扣率");
        return aiExclusiveRate;
      }
      console.log("計算全方位與智能專屬之間的折扣率");
      return allCheckupRate.sub(
        (allCheckupRate.sub(aiExclusiveRate))
          .mul((allCheckupPrice.sub(originalPrice)))
          .div((allCheckupPrice.sub(aiExclusivePrice)))
      );
    } 
    // 當目前原價大於等於基礎方案價格時
    else if (originalPrice.gte(basicCheckupPrice)) {
      if (originalPrice.eq(basicCheckupPrice)){
        console.log("使用基礎折扣率");
        return basicCheckupRate;
      }
      console.log("計算智能專屬與基礎之間的折扣率");
      return aiExclusiveRate.sub(
        ((aiExclusiveRate.sub(basicCheckupRate))).mul((aiExclusivePrice.sub(originalPrice)))
          .div((aiExclusivePrice.sub(basicCheckupPrice)))
      );
    } 
    // 當目前原價小於基礎方案價格時
    else {
      console.log("原價小於基礎方案價格時，使用基礎折扣率");
      return new Decimal(basicCheckupRate);
    }
  }

  // 取得全方位方案原始價格
  get allCheckupOriginalPrice(): number {
    return this.userPlanResponse?.allCheckup?.packageList.reduce((total, packageInfo) => {
      const packageTotal = packageInfo.examItemList.reduce((sum, examInfo) => {
        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
        return sum + originalPrice.toNumber();
      }, 0);
      return total + packageTotal;
    }, 0) ?? 0;
  }

  // 取得智能專屬方案原始價格
  get aiExclusiveOriginalPrice(): number {
    return this.userPlanResponse?.aiExclusive?.packageList.reduce((total, packageInfo) => {
      const packageTotal = packageInfo.examItemList.reduce((sum, examInfo) => {
        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
        return sum + originalPrice.toNumber();
      }, 0);
      return total + packageTotal;
    }, 0) ?? 0;
  }

  // 取得基礎方案原始價格
  get basicCheckupOriginalPrice(): number {
    return this.userPlanResponse?.basicCheckup?.packageList.reduce((total, packageInfo) => {
      const packageTotal = packageInfo.examItemList.reduce((sum, examInfo) => {
        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
        return sum + originalPrice.toNumber();
      }, 0);
      return total + packageTotal;
    }, 0) ?? 0;
  }


  // 根據已勾選的檢項初始化互斥檢項
  private initializeMutexInfos(response: CheckSuggestionsBundleResponse | CheckSuggestionsEnterpriseResponse) {

    // 檢查方案內是否有有感大腸鏡或有感胃鏡
    const packageHasScs = this.examInfoListUnderPackage.some(examInfo => 
      response?.giInfo?.scs?.includes(examInfo.examItem)
    );
    const packageHasSgs = this.examInfoListUnderPackage.some(examInfo => 
      response?.giInfo?.sgs?.includes(examInfo.examItem)
    );

    // 防止方案內與加選同時選擇兩個Scs，將加選的Scs加到互斥
    if (packageHasScs) {
      response?.giInfo?.scs?.forEach(scsItem => {
        // 只有當該Scs不在方案內時才加入互斥
        if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === scsItem)) {
          this.mutexInfos.add(scsItem);
          this.originalMutexInfos.add(scsItem);
        }
      });
    } 
    // 防止方案內與加選同時選擇兩個Sgs，將加選的Sgs加到互斥
    else if (packageHasSgs) {
      response?.giInfo?.sgs?.forEach(sgsItem => {
        // 只有當該Sgs不在方案內時才加入互斥
        if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === sgsItem)) {
          this.mutexInfos.add(sgsItem);
          this.originalMutexInfos.add(sgsItem);
        }
      });
    }
    
    // 企業預約
    if (this.sharedStorageService.get('reserveType') === '2') {
      if (response.planList.length > 0) {
        response.planList.forEach(plan => {
          plan.mutexInfos?.forEach(mutexInfo => {
            this.mutexInfos.add(mutexInfo);
            // 將原始的互斥項目保存起來
            this.originalMutexInfos.add(mutexInfo);
          });
        })
      }

      // 收集所有已勾選的檢項
      const selectedExamItems = new Set<string>();
      
      // 加入方案底下已勾選的檢項
      this.checkedExamItemListUnderPackage.forEach(examItem => {
        selectedExamItems.add(examItem);
      });
      
      // 從 sharedStorage 取得加選檢項
      const addExamItemList = this.sharedStorageService.get('addExamItemList') || [];
      addExamItemList.forEach(examInfo => {
        selectedExamItems.add(examInfo.examItem);
      });

      // 處理加選檢項的互斥初始化
      const allExamDetails = [
        ...(response.abnormalDetail || []),
        ...(response.potentialDetail || []),
        ...(response.addExamDetail || []),
      ];

      // 根據已勾選的檢項，添加對應的互斥檢項
      allExamDetails.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          // 如果這個檢項已被勾選，將它的 mutexInfos 加入互斥清單
          if (selectedExamItems.has(examInfo.examItem)) {
            examInfo.mutexInfos?.forEach((mutexItem: string) => {
              this.mutexInfos.add(mutexItem);
            });
          }
          
          // 如果這個檢項的 mutexInfos 中有任何一個被勾選，將這個檢項加入互斥清單
          const hasMutexConflict = examInfo.mutexInfos?.some(mutexItem => 
            selectedExamItems.has(mutexItem)
          );
          
          if (hasMutexConflict) {
            const isPackageItem = this.examInfoListUnderPackage.some(
              packageExam => packageExam.examItem === examInfo.examItem
            );
            // 避免把方案內檢項加進去互斥
            if (!isPackageItem) {
              this.mutexInfos.add(examInfo.examItem);
            }
          }
        });
      });

      console.log('企業預約 - 根據已勾選項目初始化互斥檢項:', this.mutexInfos);

      // 若方案內有scs/sgs,將其他scs/sgs加入互斥
      this.addGiMutexForEnterprise();
    } 
    // 個人預約
    else {
      // 確保從 storage 取得的資料轉換為 Set
      const storedMutexItems = this.sharedStorageService.get('mutexItems');
      if (storedMutexItems && Array.isArray(storedMutexItems)) {
        this.mutexInfos = new Set(storedMutexItems);
      } else if (storedMutexItems instanceof Set) {
        this.mutexInfos = storedMutexItems;
      } else {
        this.mutexInfos = new Set<string>();
      }

      const allExamDetails = [
        ...(response.abnormalDetail || []),
        ...(response.potentialDetail || []),
        ...(response.addExamDetail || []),
      ];

      // 收集所有已勾選的檢項
      const selectedExamItems = new Set<string>();
      
      // 加入方案底下已勾選的檢項
      this.checkedExamItemListUnderPackage.forEach(examItem => {
        selectedExamItems.add(examItem);
      });
      
      // 加入加選檢項中已勾選的檢項
      this.checkedExamInfoList.forEach(examInfo => {
        selectedExamItems.add(examInfo.examItem);
      });

      console.log('已勾選的檢項:', Array.from(selectedExamItems));

      // 根據已勾選的檢項，添加對應的互斥檢項
      allExamDetails.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          // 邏輯1：如果這個檢項已被勾選，將它的 mutexInfos 加入互斥清單
          if (selectedExamItems.has(examInfo.examItem)) {
            examInfo.mutexInfos?.forEach((mutexItem: string) => {
              this.mutexInfos.add(mutexItem);
              console.log('因為勾選了', examInfo.examItem, '所以加入互斥檢項:', mutexItem);
            });
          }
          
          // 邏輯2：如果這個檢項的 mutexInfos 中有任何一個被勾選，將這個檢項加入互斥清單
          const hasMutexConflict = examInfo.mutexInfos?.some(mutexItem => 
            selectedExamItems.has(mutexItem)
          );
          
          if (hasMutexConflict) {
            const isPackageItem = this.examInfoListUnderPackage.some(
              packageExam => packageExam.examItem === examInfo.examItem
            );
            // 避免把方案內檢項加進去互斥
            if (!isPackageItem) {
              this.mutexInfos.add(examInfo.examItem);
              console.log('因為已勾選項目衝突，所以加入互斥檢項:', examInfo.examItem);
            }
          }
        });
      });

      // 處理熱門檢項
      response.hotExamItemDetail?.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          if (selectedExamItems.has(examInfo.examItem)) {
            examInfo.mutexInfos?.forEach((mutexItem: string) => {
              this.mutexInfos.add(mutexItem);
            });
          }
        });
      });

      console.log('根據已勾選項目初始化互斥檢項:', this.mutexInfos);

    }
  }


  // 判斷是否需要加麻醉(彈窗)
  get addAnesthesia(): number | undefined {
    // 根據預約類型選擇對應的回應資料
    const isEnterprise = this.sharedStorageService.get('reserveType') === '2';
    // 企業：checkSuggestionsEnterpriseResponse
    // 個人：checkSuggestionsResponse
    const giInfo = isEnterprise ? this.checkSuggestionsEnterpriseResponse?.giInfo : this.checkSuggestionsResponse?.giInfo;

    // 原方案是否有有感胃鏡
    const originalHasSgs = this.examInfoListUnderPackage.some(examInfo => 
      examInfo.selectFlag === 1 &&
      giInfo?.sgs?.includes(examInfo.examItem)
    );
    // 原方案是否有有感大腸鏡
    const originalHasScs = this.examInfoListUnderPackage.some(examInfo => 
      examInfo.selectFlag === 1 &&
      giInfo?.scs?.includes(examInfo.examItem)
    );
    // 原方案是否有無感胃鏡
    const originalHasNsGs = this.examInfoListUnderPackage.some(examInfo => 
      examInfo.selectFlag === 1 &&
      giInfo?.nsGs?.includes(examInfo.examItem)
    );
    // 原方案是否有無感大腸鏡
    const originalHasNsCs = this.examInfoListUnderPackage.some(examInfo => 
      examInfo.selectFlag === 1 &&
      giInfo?.nsCs?.includes(examInfo.examItem)
    );
    // 原方案是否有單項麻醉
    const originalHasSAn = this.examInfoListUnderPackage.some(examInfo => 
      examInfo.selectFlag === 1 &&
      giInfo?.san?.includes(examInfo.examItem)
    );
    // 加選是否有有感胃鏡
    const addedHasSgs = this.checkedExamInfoList.some(examInfo => 
      giInfo?.sgs?.includes(examInfo.examItem)
    );
    // 加選是否有有感大腸鏡
    const addedHasScs = this.checkedExamInfoList.some(examInfo => 
      giInfo?.scs?.includes(examInfo.examItem)
    );
    // 加選是否有無感胃鏡
    const addedHasNsGs = this.checkedExamInfoList.some(examInfo => 
      giInfo?.nsGs?.includes(examInfo.examItem)
    );
    // 加選是否有無感大腸鏡
    const addedHasNsCs = this.checkedExamInfoList.some(examInfo => 
      giInfo?.nsCs?.includes(examInfo.examItem)
    );

    // 是否加選或方案內有有感胃鏡
    const hasSgs = giInfo?.sgs?.some(examItem => 
      this.checkedExamItemListUnderPackage.includes(examItem) || 
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
    );
    console.log('有沒有sgs加選：', this.checkedExamInfoList);
    console.log('加選回傳giInfo：', giInfo?.sgs);
    console.log('hasSgs:', hasSgs);

    // 是否加選或方案內有有感大腸鏡
    const hasScs = giInfo?.scs?.some(examItem => 
      this.checkedExamItemListUnderPackage.includes(examItem) || 
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
    );

    // 單項麻醉
    const sanExamItem = this.getAnesthesiaExamItem('sAn');
    console.log('sanExamItem:', sanExamItem);
  
    // 是否加選或方案內有單項麻醉
    const hasSAn = sanExamItem && sanExamItem.some(examItem => 
      this.checkedExamItemListUnderPackage.includes(examItem) || 
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
    );
    
    // 雙項麻醉
    const danExamItem = this.getAnesthesiaExamItem('dAn');
    console.log('danExamItem:', danExamItem);

    // 是否加選或方案內有雙項麻醉
    const hasDAn = danExamItem && danExamItem.some(examItem => 
      this.checkedExamItemListUnderPackage.includes(examItem) || 
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
    );

    // 套檢麻醉
    const tAnExamItem = this.getAnesthesiaExamItem('tAn');
    console.log('tAnExamItem:', tAnExamItem);
    const hasTAn = tAnExamItem && tAnExamItem.some(examItem => 
      this.checkedExamItemListUnderPackage.includes(examItem) || 
      this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
    );
    // 沒有腸胃鏡但有單項麻醉的情況
    const hasAnesthesiaWithoutGI = !hasScs && !hasSgs && hasSAn;

    // 當有有感腸胃鏡檢項時，檢查是否有對應的單項麻醉
    const needsAnesthesia = (hasScs || hasSgs) && sanExamItem && (
      (Array.isArray(sanExamItem) && !sanExamItem.some(examItem => 
        this.checkedExamItemListUnderPackage.includes(examItem) || 
        this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
      ))
    );

    // 當有有感腸胃鏡檢項時，檢查是否有對應的雙項麻醉
    const needsDAnesthesia = (hasScs && hasSgs) && danExamItem && (
      (Array.isArray(danExamItem) && !danExamItem.some(examItem => 
        this.checkedExamItemListUnderPackage.includes(examItem) || 
        this.checkedExamInfoList.some(examInfo => examInfo.examItem === examItem)
      ))
    );

    // 方案內只有一個有感腸胃鏡，且有單項麻醉
    const hasOnlyOneGiInPackage = ((hasSgs && !hasScs) || (hasScs && !hasSgs)) && hasDAn;

    // 第一種判斷：沒有任何加退選動作，原方案進行下一步
    if (this.checkedExamItemListUnderPackage.length === this.examInfoListUnderPackage.length &&
        this.examInfoListUnderPackage.every(examInfo => 
          this.checkedExamItemListUnderPackage.includes(examInfo.examItem)
        ) &&
        this.checkedExamInfoList.length === 0) {

          // 企業預約
          if (this.sharedStorageService.get('reserveType') === '2') {
            // 方案內只有一個有感腸胃鏡，且沒有單項麻醉
            if (((hasSgs && !hasScs) && (!hasSAn && !hasTAn)) || ((hasScs && !hasSgs) && (!hasSAn && !hasTAn))) {
              console.log("第一種判斷：方案內只有一個有感腸胃鏡，且沒有單項麻醉與麻醉(套檢)PE001000，彈窗詢問麻醉");
              if (this.anesthesiaChoice === undefined) {
                this.showAddAnesthesiaDialog();
                return undefined; // 等待使用者選擇
              }
              return this.anesthesiaChoice;
            }
            // 方案內或加選有 有感大腸鏡 或 有感胃鏡，且還有方案麻醉(套檢)PE001000
            else if ((hasSgs || hasScs) && hasTAn) {
              console.log('第一種判斷，方案內有有感大腸鏡和有感胃鏡，且還有方案麻醉(套檢)PE001000，直接通過');
              return 2;
            }
            // 方案內有有感大腸鏡和有感胃鏡，且沒有雙項麻醉 
            else if (hasSgs && hasScs) {
              console.log("第一種判斷：方案內或加選有有感大腸鏡和有感胃鏡，且沒有雙項麻醉，彈窗詢問麻醉");
              if (this.anesthesiaChoice === undefined) {
                this.showAddAnesthesiaDialog();
                return undefined; // 等待使用者選擇
              }
              return this.anesthesiaChoice;
            }
            // 個人預約
          } else {
            console.log("第一種判斷：沒有任何加退選動作，原方案進行下一步");
            return 2;
          }
        return this.anesthesiaChoice;
    } 
    // 第二種判斷：方案內有有感大腸鏡，且加選了無感胃鏡，或方案內有有感胃鏡，且加選了無感大腸鏡，也有升級麻醉
    else if (((originalHasScs && addedHasNsGs) || 
            (originalHasSgs && addedHasNsCs) || 
            (originalHasNsCs && addedHasSgs) || 
            (originalHasNsGs && addedHasScs))
            ) {
      console.log("第二種判斷：方案內有有感大腸鏡，且加選了無感胃鏡，或方案內有有感胃鏡，且加選了無感大腸鏡，也有升級麻醉");
      return 2;
    }
    // 第三種判斷：若加選或方案內有無感腸鏡或胃鏡，則不須彈窗
    else if (originalHasNsCs || originalHasNsGs || addedHasNsCs || addedHasNsGs) {
      console.log('第三種判斷：方案內或加選有無感腸鏡或胃鏡，不須彈窗詢問麻醉');
      return 2;
    }
    // 第四種判斷：方案內有無感腸胃鏡，或是加選了無感腸胃鏡，則不需加麻醉
    else if (giInfo?.nsGi?.[0] && 
               (this.checkedExamItemListUnderPackage.includes(giInfo.nsGi[0]) || 
                this.checkedExamInfoList.some(examInfo => examInfo.examItem === giInfo?.nsGi?.[0])) 
    ) {
      console.log("第四種判斷：方案內有無感腸胃鏡，或是加選了無感腸胃鏡，則不需加麻醉");
      return 2;
      // 第五種判斷：有腸胃鏡且有雙項麻醉，直接通過
    } else if (hasDAn && hasScs && hasSgs) {
      console.log("第五種判斷：有腸胃鏡且有雙項麻醉，直接通過");
      return 2;
    } 
    // 第六種判斷：有腸胃鏡且有麻醉(套檢)PE001000，且有單項麻醉或雙項麻醉，刪除單項或雙項麻醉
    else if ((hasScs || hasSgs) && hasTAn && (hasSAn || hasDAn)) {
      console.log('第六種判斷：有腸胃鏡且有麻醉(套檢)PE001000，且有單項麻醉或雙項麻醉，刪除單項或雙項麻醉');
      return 2;
    }
    // 第七種判斷：有腸鏡或胃鏡且有單項麻醉，直接通過
    else if ((hasScs && hasSAn && !hasSgs) || (hasSgs && hasSAn && !hasScs)) {
      console.log("第七種判斷：有腸鏡或胃鏡且有單項麻醉，直接通過");
      return 2;
    }
    // 第八種判斷：有腸鏡或胃鏡且有雙項麻醉，刪除雙項麻醉，加入單項麻醉
    else if ((hasScs || hasSgs) && hasDAn) {
      console.log("第八種判斷：有腸鏡或胃鏡且有雙項麻醉，刪除雙項麻醉，加入單項麻醉，不須彈窗");
      return 2;
      // if (this.anesthesiaChoice === undefined) {
      //   this.showAddAnesthesiaDialog();
      //   return undefined; // 等待使用者選擇
      // }
      // if (this.anesthesiaChoice === 1) {
      //   // 若雙項麻醉在方案內
      //   if (danExamItem && danExamItem.some(examItem => this.checkedExamItemListUnderPackage.includes(examItem))) {
      //     this.checkedExamItemListUnderPackage = this.checkedExamItemListUnderPackage.filter(examItem => !danExamItem.includes(examItem));
      //     danExamItem.forEach(danItem => {
      //       const examInfo = this.examInfoListUnderPackage.find(examInfo => examInfo.examItem === danItem);
      //       if (examInfo) {
      //         this.removeItemQuestionMap.push(examInfo);
      //         this.mutexInfos.add(examInfo.examItem);
      //       }
      //     });
      //     // 將雙項麻醉selectFlag設為0
      //     const examItemList = this.examInfoListUnderPackage.map(
      //       (examInfo: ExamInfo) => {
      //         examInfo.selectFlag = 0;
      //         return examInfo;
      //       }
      //     );
      //     // 更新原始總價
      //     this.originalPrice = this.examInfoListUnderPackage
      //       .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
      //       .reduce((total, examInfo) => {
      //         return total.add(new Decimal(examInfo.examPrice ?? 0));
      //       }, new Decimal(0));

      //     const discountedPackagePrice = this.examInfoListUnderPackage
      //       .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
      //       .reduce((total, examInfo) => {
      //         const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
      //         if (examInfo.rateStatus === true) {
      //           let discountedPrice = originalPrice.mul(this.movedDiscountRate(this.originalPrice));//檢項套用折扣
      //           let roundedPrice = discountedPrice.div(10).ceil().mul(10);//無條件10進位

      //           // 若有活動折扣率
      //           if (this.partyDiscountRate) {
      //             roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
      //             // 四捨五入到個位整數
      //             roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
      //           }  
      //           return total + roundedPrice.toNumber();
      //         } else {
      //           return total + originalPrice.toNumber();
      //         }
      //       }, 0);

      //     this.sharedStorageService.set('mutexItems', this.mutexInfos);
      //     this.sharedStorageService.set('originalPrice', discountedPackagePrice);
      //     this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
      //     this.sharedStorageService.set('examItemList', examItemList);
      //     this.refreshShoppingCart();
      //   }
      //   // 若雙項麻醉在加選
      //   if (danExamItem && danExamItem.some(danItem => this.checkedExamInfoList.some(examInfo => examInfo.examItem === danItem))) {
      //     this.checkedExamInfoList = this.checkedExamInfoList.filter(
      //       examInfo => !danExamItem.includes(examInfo.examItem)
      //     );
      //     this.refreshShoppingCart();
      //   }
      // }
      // return this.anesthesiaChoice;
    }
    // 第九種判斷：方案或加選同時有有感腸胃鏡且有單項麻醉時，不需彈窗，直接單升雙麻
    else if ((hasSgs && hasScs && hasSAn)) {
      console.log('第九種判斷：方案或加選同時有有感腸胃鏡且有單項麻醉時，不需彈窗，直接單升雙麻');
      return 2;
    }
    // 第十種判斷：方案或加選同時有有感腸胃鏡且有麻醉(套檢)PE001000時，不需彈窗
    else if (needsDAnesthesia && hasTAn) {
      console.log('第十種判斷：方案或加選同時有有感腸胃鏡且有麻醉(套檢)PE001000時，不需彈窗');
      return 2;
    }
    // 十一種判斷：當有有感大腸鏡和有感胃鏡檢項時，檢查是否有對應的雙項麻醉，如果沒有則彈窗 
    else if (needsDAnesthesia && !hasTAn) {
      console.log("第十一種判斷：有有感大腸鏡和有感胃鏡檢項時，檢查是否有對應的雙項麻醉，如果沒有則彈窗 ");
      if (this.anesthesiaChoice === undefined) {
        this.showAddAnesthesiaDialog();
        return undefined; // 等待使用者選擇
      }
      if (this.anesthesiaChoice === 1) {
        // 若將雙項麻醉補回，則加回購物車(方案內有)
        if (danExamItem && danExamItem.some(danItem => this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem))) {
          if (sanExamItem) {
            if (sanExamItem.some(sanItem => this.checkedExamInfoList.some(examInfo => examInfo.examItem === sanItem))) {
              this.checkedExamInfoList = this.checkedExamInfoList.filter(
                examInfo => !sanExamItem.includes(examInfo.examItem)
              );
            }
            this.sharedStorageService.set('addExamItemList', this.checkedExamInfoList);
          }
          // 從移除清單中移除
          if (danExamItem) {
            this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
              item => !danExamItem.includes(item.examItem)
            );

            // 將方案內的雙項麻醉勾選起來
            danExamItem.forEach(danItem => {
              if (!this.checkedExamItemListUnderPackage.includes(danItem)) {
                this.checkedExamItemListUnderPackage.push(danItem);
              }
            });
          }
          this.refreshShoppingCart();
          this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
        } 
        // 方案內沒有雙項麻醉，則新增加選檢項(方案外)
        else if (danExamItem && !danExamItem.some(danItem => this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === danItem))) {
          // const danInfo = this.checkSuggestionsEnterpriseResponse?.giInfo?.dan;
          // if (danInfo && typeof danInfo === 'object') {
          //   this.checkedExamInfoList.push({
          //     examName: danInfo.examName,
          //     examItem: danInfo.examItem,
          //     examMemo: danInfo.examMemo ?? '',
          //     price: danInfo.price ?? '0',
          //   });
          // }
          // this.sharedStorageService.set('addExamItemList', this.checkedExamInfoList);
          this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
            item => !danExamItem.includes(item.examItem)
          );
          this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
          this.refreshShoppingCart();
        }
      }
      this.originalPrice = this.examInfoListUnderPackage
        .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
        .reduce((total, examInfo) => {
          return total.add(new Decimal(examInfo.examPrice ?? 0));
        }, new Decimal(0));
      const discountedPackagePrice = this.examInfoListUnderPackage
        .filter(examInfo => this.checkedExamItemListUnderPackage.includes(examInfo.examItem))
        .reduce((total, examInfo) => {
          const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
          if (examInfo.rateStatus === true) {
            const discountedPrice = originalPrice.mul(this.movedDiscountRate(this.originalPrice));//檢項套用折扣
            let roundedPrice = discountedPrice.div(10).ceil().mul(10);//無條件10進位
            // 若有活動折扣率
            if (this.partyDiscountRate) {
              roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
              // 四捨五入到個位整數
              roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
            }
            return total + roundedPrice.toNumber();
          } else {
            return total + originalPrice.toNumber();
          }
        }, 0);
        this.sharedStorageService.set('originalPrice', discountedPackagePrice);
      return this.anesthesiaChoice;
    }
    // 第十二種判斷：當有有感大腸鏡或有感胃鏡檢項時，檢查是否有對應的單項麻醉，如果沒有則彈窗
    else if (needsAnesthesia) {
      console.log("第十二種判斷：有腸鏡或胃鏡，但沒有麻醉，彈窗");
      if (this.anesthesiaChoice === undefined) {
        this.showAddAnesthesiaDialog();
        return undefined; // 等待使用者選擇
      }
      if (this.anesthesiaChoice === 1) {
        // 若將單項麻醉補回，則加回購物車(方案內有)
        if (sanExamItem && sanExamItem.some(sanItem => this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === sanItem))) {

          // 從移除清單中移除
          this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
            item => !sanExamItem.includes(item.examItem)
          );
          this.refreshShoppingCart();
          this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
          // 方案內沒有單項麻醉，則新增加選檢項(方案外)
        } else if (sanExamItem && !sanExamItem.some(sanItem => this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === sanItem))) {

          this.removeItemQuestionMap = this.removeItemQuestionMap.filter(
            item => !sanExamItem.includes(item.examItem)
          );
          this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
          this.refreshShoppingCart();
        }
      }
      return this.anesthesiaChoice;
      
    }
    // 第十三種判斷：當沒有腸胃鏡但有單項麻醉時，移除麻醉
    else if (hasAnesthesiaWithoutGI) {
      console.log("第十三種判斷：方案內有單項麻醉，但沒有腸胃鏡");
      return 2;
      // 第十四種判斷：當有加退選動作，把腸鏡 or 胃鏡 and 單麻 取消時，移除麻醉
    } else if (!hasSgs && !hasScs && !hasSAn) {
      console.log("第十四種判斷：無麻醉檢項，刪除麻醉");
      return 2;
      /* 第十五種判斷：當方案內有有感胃鏡 + 單麻，且加選了有感大腸鏡時，彈窗升雙麻
                    當方案內有有感大腸鏡 + 單麻，且加選了有感胃鏡時，彈窗升雙麻  */
    } else if (originalHasSAn && ((originalHasSgs && addedHasScs) || (originalHasScs && addedHasSgs))) {
      if (this.anesthesiaChoice === undefined) {
        console.log("第十五種判斷：升雙項麻醉");
        this.showAddAnesthesiaDialog();
        return undefined; // 等待使用者選擇
      }
      return this.anesthesiaChoice;
      // 第十六種判斷：當方案內沒有有感胃鏡與大腸鏡，加選了有感胃鏡或大腸鏡時，彈窗升單麻
    } else if ((addedHasSgs || addedHasScs) && !hasSAn) {
      console.log("第十六種判斷：加選有感腸胃鏡，但沒有單項麻醉");
      if (this.anesthesiaChoice === undefined) {
        this.showAddAnesthesiaDialog();
        return undefined; // 等待使用者選擇
      }
      return this.anesthesiaChoice;
      // 第十七種判斷：當方案內有有感大腸鏡，且移除了有感大腸鏡並加選有感胃鏡時，彈窗升單麻
      //            當方案內有有感胃鏡，且移除了有感胃鏡並加選有感大腸鏡時，彈窗升單麻
    } else if ((originalHasScs && !hasScs && addedHasSgs) || (originalHasSgs && !hasSgs && addedHasScs)) {
      console.log("第十七種判斷：加退選升單麻");
      if (this.anesthesiaChoice === undefined) {
        this.showAddAnesthesiaDialog();
        return undefined;
      }
      return this.anesthesiaChoice;

      // 第十八種判斷：方案內只有一個有感腸胃鏡，不需要升雙項麻醉
    } else if (hasOnlyOneGiInPackage) {
      console.log("第十八種判斷：方案內只有一個有感腸胃鏡，不需要雙項麻醉");
      return 2;
      // 第十九種判斷：方案內沒有任何有感腸胃鏡，移除雙項及單項麻醉
    } else if (!hasSgs && !hasScs) {
      console.log("第十九種判斷：方案沒有任何腸胃鏡，移除雙項及單項麻醉");
      this.checkedExamItemListUnderPackage =
      this.checkedExamItemListUnderPackage.filter(
          item => !danExamItem?.includes(item) && !sanExamItem?.includes(item)
      );
      this.checkedExamInfoList = this.checkedExamInfoList.filter(
        item => !danExamItem?.includes(item.examItem) && !sanExamItem?.includes(item.examItem)
      );

      const danExamInfo = danExamItem ? danExamItem.map(item => this.examInfoListUnderPackage.find(examInfo => examInfo.examItem === item)).filter(Boolean) : undefined;
      const sanExamInfo = sanExamItem ? sanExamItem.map(item => this.examInfoListUnderPackage.find(examInfo => examInfo.examItem === item)).filter(Boolean) : undefined;

      if (danExamInfo) {
        danExamInfo.forEach(examInfo => {
          if (examInfo && !this.removeItemQuestionMap.some(item => item.examItem === examInfo.examItem)) {
            this.removeItemQuestionMap.push(examInfo);
          }
        });
      }
      if (sanExamInfo) {
        sanExamInfo.forEach(examInfo => {
          if (examInfo && !this.removeItemQuestionMap.some(item => item.examItem === examInfo.examItem)) {
            this.removeItemQuestionMap.push(examInfo);
          }
        });
      }
      this.sharedStorageService.set('removeItemQuestionMap', this.removeItemQuestionMap);
      this.refreshShoppingCart();
      return 2;
    }
    else {
      console.log("判斷失敗");
      return undefined;
    }
  }

  // 顯示加麻醉的彈窗
  private showAddAnesthesiaDialog() {
    const addAnesthesiaDialog = this.dialog.open(DuoActionDialogComponent, {
      disableClose: true,
      data: {
        title: this.translateService.instant('reserve-add.have-sleep-title'),
        message: this.translateService.instant('reserve-add.make-comfortable'),
        leftButtonText: this.translateService.instant('reserve-add.delete-sleep'),
        rightButtonText: this.translateService.instant('reserve-add.keep-sleep'),
        leftButtonAction: () => {
          this.anesthesiaChoice = 0; // 不需要麻醉
          addAnesthesiaDialog.close();
          this.OnChangeToRequiredItems().pipe(take(1)).subscribe(() => {
            // 更新 SharedStorage 後通知 overview 刷新
            this.refreshOverviewPage();
          });
        },
        rightButtonAction: () => {
          this.anesthesiaChoice = 1; // 需要麻醉 or 升雙項麻醉
          addAnesthesiaDialog.close();
          this.OnChangeToRequiredItems().pipe(take(1)).subscribe(() => {
            // 更新 SharedStorage 後通知 overview 刷新
            this.refreshOverviewPage();
          });
        },
      },
    });
  }

  // 刷新 overview 頁面的方法
  private refreshOverviewPage() {
    if (this.router.url.includes('/healthcheck/reserve/overview')) {
      this.router.navigateByUrl('/healthcheck/reserve', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/healthcheck/reserve/overview']);
      });
    }
  }

  // 取得個別examType底下deptName是否展開
  getDeptOpenStateByExamType(examType: string, deptName: string) {
    return this.isDeptNameOpenByExamType.get(examType)?.get(deptName) ?? false;
  }

  // 切換個別examType底下deptName的展開狀態
  toggleDeptOpenStateByExamType(examType: string, deptName: string) {
    if (!this.isDeptNameOpenByExamType.has(examType)) {
      this.isDeptNameOpenByExamType.set(examType, new Map<string, boolean>());
    }
    const deptMap = this.isDeptNameOpenByExamType.get(examType)!;
    deptMap.set(deptName, !(deptMap.get(deptName) ?? false));
  }

  // 檢查檢項是否在方案內
  isExamInPackage(examItem: string): boolean {
    return this.examInfoListUnderPackage.some(item => item.examItem === examItem);
  }

  // 檢查互斥檢項是否被其他已勾選檢項共享
  private isSharedMutexInfo(mutexInfo: string, excludeExamItem: string): boolean {
    // 企業預約:檢查是否為腸胃鏡相關的互斥
    if (this.sharedStorageService.get('reserveType') === '2') {
      const giInfo = this.checkSuggestionsEnterpriseResponse?.giInfo;
      if (giInfo) {
        // 檢查是否還有其他scs被勾選(排除當前取消的檢項)
        const stillHasScs = this.checkedExamInfoList.some(item => 
          item.examItem !== excludeExamItem && giInfo.scs?.includes(item.examItem)
        ) || this.checkedExamItemListUnderPackage.some(item => 
          item !== excludeExamItem && giInfo.scs?.includes(item)
        );

        // 檢查是否還有其他sgs被勾選(排除當前取消的檢項)
        const stillHasSgs = this.checkedExamInfoList.some(item => 
          item.examItem !== excludeExamItem && giInfo.sgs?.includes(item.examItem)
        ) || this.checkedExamItemListUnderPackage.some(item => 
          item !== excludeExamItem && giInfo.sgs?.includes(item)
        );

        // 如果mutexInfo是nsCs或nsGi,且還有scs被勾選,則仍需保留互斥
        if ((giInfo.nsCs?.includes(mutexInfo) || giInfo.nsGi?.includes(mutexInfo)) && stillHasScs) {
          return true;
        }

        // 如果mutexInfo是nsGs或nsGi,且還有sgs被勾選,則仍需保留互斥
        if ((giInfo.nsGs?.includes(mutexInfo) || giInfo.nsGi?.includes(mutexInfo)) && stillHasSgs) {
          return true;
        }
      }
    }

    // 檢查方案內已勾選檢項
    for (const checkedExamItem of this.checkedExamItemListUnderPackage) {
      if (checkedExamItem === excludeExamItem) continue;

      // 從 allExamDetail 中找到對應的 AddExamInfo 來取得 mutexInfos
      let allExamInfo: AddExamInfo | undefined;
      if (this.allExamDetail) {
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            const foundExamInfo = examDetail.examItemList?.find(
              item => item.examItem === checkedExamItem
            );
            if (foundExamInfo) {
              allExamInfo = foundExamInfo;
              break;
            }
          }
          if (allExamInfo) break;
        }
      }
      if (allExamInfo?.mutexInfos?.includes(mutexInfo)) {
        return true;
      }
    }

    // 檢查加選已勾選檢項
    for (const checkedExamInfo of this.checkedExamInfoList) {
      if (checkedExamInfo.examItem === excludeExamItem) continue;
      
      if (checkedExamInfo.mutexInfos?.includes(mutexInfo)) {
        return true;
      }
    }

    // 新增:反向查找 - 檢查要移除的互斥項目是否仍與方案內檢項互斥
    for (const packageExamInfo of this.examInfoListUnderPackage) {
      if (packageExamInfo.examItem === excludeExamItem) continue;

      // 修改：只檢查已勾選的方案內檢項
      if (!this.checkedExamItemListUnderPackage.includes(packageExamInfo.examItem)) {
        continue;
      }
      
      // 從 allExamDetail 找到該互斥項目的完整資訊
      let mutexExamInfo: AddExamInfo | undefined;
      if (this.allExamDetail) {
        for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
          for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
            const found = examDetail.examItemList?.find(
              item => item.examItem === mutexInfo
            );
            if (found) {
              mutexExamInfo = found;
              break;
            }
          }
          if (mutexExamInfo) break;
        }
      }
      
      // 反向檢查:該互斥項目的 mutexInfos 是否包含方案內檢項
      if (mutexExamInfo?.mutexInfos?.includes(packageExamInfo.examItem)) {
        console.log('反向查找:因方案內檢項', packageExamInfo.examItem, '與', mutexInfo, '互斥,保留反灰');
        return true;
      }
    }

    return false;
  }

  /**
   * 統一取得麻醉檢項代碼
   * 個人：giInfo.san 是 String，直接回傳
   * 企業：giInfo.san 是 Object，取 .examItem
   */
  private getAnesthesiaExamItem(type: 'sAn' | 'dAn' | 'tAn'): string[] | undefined {
    const isEnterprise = this.sharedStorageService.get('reserveType') === '2';
    const giInfo = isEnterprise 
      ? this.checkSuggestionsEnterpriseResponse?.giInfo 
      : this.checkSuggestionsResponse?.giInfo;

    if (!giInfo) return undefined;

    let value: string[] | undefined;
    
    switch(type) {
      case 'sAn':
        value = giInfo.san;
        break;
      case 'dAn':
        value = giInfo.dan;
        break;
      case 'tAn':
        value = giInfo.tan;
        break;
    }
    return value;
  }

  // 判斷是否為加選互斥檢項
  isAddedExamMutex(examItem: string): boolean {
    return this.checkedExamInfoList.some(addedExam => 
      addedExam.mutexInfos?.includes(examItem)
    );
  }

  // 判斷是否為原方案的互斥檢項 (for加選檢查互斥)
  isOriginalPackageMutex(examItem: string): boolean {
    if (this.sharedStorageService.get('reserveType') !== '2') {
      return false;
    }
    
    // 檢查是否在初始化時就已經是互斥項目
    return this.originalMutexInfos?.has(examItem) ?? false;
  }

  // 是否應該顯示異常追蹤的tab
  get shouldShowAbnormalTrackingButton(): boolean {
    const abnormalDetail = this.checkSuggestionsEnterpriseResponse?.abnormalDetail;
    if (!abnormalDetail || abnormalDetail.length === 0) return false;

    if (abnormalDetail.length === 1 && abnormalDetail[0]?.examItemList?.length === 1 &&
      (this.isExamInPackage(abnormalDetail[0]?.examItemList[0]?.examItem) || this.mutexInfos.has(abnormalDetail[0]?.examItemList[0]?.examItem))
    ) {
      console.log('不應該顯示個人歷史異常追蹤tab');
      if (this.checkSuggestionsEnterpriseResponse?.potentialDetail && this.checkSuggestionsEnterpriseResponse.potentialDetail.length > 0) {
        this.searchType = 2;
      } else if (this.checkSuggestionsEnterpriseResponse?.basicCheckup && this.checkSuggestionsEnterpriseResponse.basicCheckup.length > 0) {
        this.searchType = 3;
      } else {
        this.searchType = 4;
      }
      return false;
    }

    return true;
  }


  get shouldShowBasicCheckupButton(): boolean {
    const basicCheckup = this.checkSuggestionsEnterpriseResponse?.basicCheckup;
    if (!basicCheckup) return false;

    if (basicCheckup.length === 1 && basicCheckup[0]?.examItemList?.length === 1 &&
      this.isExamInPackage(basicCheckup[0]?.examItemList[0]?.examItem)
    ) {
      console.log('不應該顯示優先必要檢查項目tab');
      return false;
    }

    return true;
  }

  // 取得加選abnormalRatio，並且來做排序
  get sortedExamInfoList(): AddExamInfo[] {
    const sorted = [...this.examInfoList].sort((a, b) => {
      const ratioA = Number(a.abnormalRatio) || 0;
      const ratioB = Number(b.abnormalRatio) || 0;
      return ratioB - ratioA; // 由大到小排序
    });
    
    console.log('排序後的檢項列表:', sorted.map(item => ({
      examName: item.examName,
      abnormalRatio: item.abnormalRatio
    })));
    
    return sorted;
  }

  // 判斷該檢項的互斥列表是否包含方案內檢項
  hasMutexWithPackageItems(examItem: string): boolean {
    if (this.sharedStorageService.get('reserveType') !== '2') {
      return false;
    }

    // 從 allExamDetail 中找到該檢項的資訊
    let examInfo: AddExamInfo | undefined;
    if (this.allExamDetail) {
      for (const examDetailList of this.allExamDetail.filter(list => Array.isArray(list))) {
        for (const examDetail of examDetailList.filter(detail => detail?.examItemList)) {
          const found = examDetail.examItemList?.find(item => item.examItem === examItem);
          if (found) {
            examInfo = found;
            break;
          }
        }
        if (examInfo) break;
      }
    }

    // 檢查該檢項的 mutexInfos 是否包含任何方案內檢項
    if (examInfo?.mutexInfos) {
      return examInfo.mutexInfos.some(mutexItem => 
        this.isExamInPackage(mutexItem)
      );
    }

    return false;
  }

  // 判斷該方案若已有腸鏡或胃鏡(scs or sgs)，則將其他有感腸胃鏡互斥
  addGiMutexForEnterprise(): void {
    if (this.sharedStorageService.get('reserveType') !== '2') {
      return;
    }
    const giInfo = this.checkSuggestionsEnterpriseResponse?.giInfo;
    if (!giInfo) return;

    // 檢查方案內是否有有感大腸鏡
    const packageHasScs = this.examInfoListUnderPackage.some(examInfo => 
      giInfo.scs?.includes(examInfo.examItem)
    );

    // 檢查方案內是否有有感胃鏡
    const packageHasSgs = this.examInfoListUnderPackage.some(examInfo => 
      giInfo.sgs?.includes(examInfo.examItem)
    );

    // 若方案內有scs,將其他scs加入互斥
    if (packageHasScs && giInfo.scs) {
      giInfo.scs.forEach(scsItem => {
        if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === scsItem)) {
          this.mutexInfos.add(scsItem);
          this.originalMutexInfos.add(scsItem);
          console.log('企業預約 - 因方案內有scs,將其他scs加入互斥:', scsItem);
        }
      });
      
      // 將無痛大腸鏡也加入互斥
      if (giInfo.nsCs) {
        giInfo.nsCs.forEach(nscsItem => {
          if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === nscsItem)) {
            this.mutexInfos.add(nscsItem);
            this.originalMutexInfos.add(nscsItem);
            console.log('企業預約 - 因方案內有scs,將nsCs加入互斥:', nscsItem);
          }
        });
      }

      // 將無痛腸胃鏡也加入互斥
      if (giInfo.nsGi) {
        giInfo.nsGi.forEach(nsgiItem => {
          if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === nsgiItem)) {
            this.mutexInfos.add(nsgiItem);
            this.originalMutexInfos.add(nsgiItem);
            console.log('企業預約 - 因方案內有scs,將nsGi加入互斥:', nsgiItem);
          }
        });
      }
    }

    // 若方案內有sgs,將其他sgs加入互斥
    if (packageHasSgs && giInfo.sgs) {
      giInfo.sgs.forEach(sgsItem => {
        if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === sgsItem)) {
          this.mutexInfos.add(sgsItem);
          this.originalMutexInfos.add(sgsItem);
          console.log('企業預約 - 因方案內有sgs,將其他sgs加入互斥:', sgsItem);
        }
      });
      
      // 將無痛胃鏡也加入互斥
      if (giInfo.nsGs) {
        giInfo.nsGs.forEach(nsgsItem => {
          if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === nsgsItem)) {
            this.mutexInfos.add(nsgsItem);
            this.originalMutexInfos.add(nsgsItem);
            console.log('企業預約 - 因方案內有sgs,將nsGs加入互斥:', nsgsItem);
          }
        });
      }

      // 將無痛腸胃鏡也加入互斥
      if (giInfo.nsGi) {
        giInfo.nsGi.forEach(nsgiItem => {
          if (!this.examInfoListUnderPackage.some(examInfo => examInfo.examItem === nsgiItem)) {
            this.mutexInfos.add(nsgiItem);
            this.originalMutexInfos.add(nsgiItem);
            console.log('企業預約 - 因方案內有sgs,將nsGi加入互斥:', nsgiItem);
          }
        });
      }
    }
  }

  // 取得所有分類底下檢項
  getExamInfosByDeptName(deptName: string): AddExamInfo[] {
    // 取得熱門檢項分類
    const hotExamName = this.translateService.instant('reserve-add.popular-deptName');

    // 處理熱門檢項
    if (deptName === hotExamName) {
      const hotExams: AddExamInfo[] = [];
      this.hotExamDetail?.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          // 檢查是否與方案內互斥
          const hasMutexWithPackageItem = examInfo.mutexInfos?.some(mutexItem =>
            this.examInfoListUnderPackage.some(
              (item: ExamInfo) => item.examItem === mutexItem
            )
          ) ?? false;

          // 只加入不與方案內檢項互斥的熱門檢項
          if (!hasMutexWithPackageItem) {
            hotExams.push({
            ...examInfo,
            deptName: hotExamName
          });
          }
        });
      });

      // 若有搜尋文字，同樣對熱門檢項套用關鍵字過濾
      if (this.quickSearchText.trim() !== '') {
        return hotExams.filter(examInfo =>
          examInfo.examName?.includes(this.quickSearchText.trim())
        );
      }
      return hotExams;
    }

    // 如果有搜尋文字,從 examInfoList 中過濾該分類
    if (this.quickSearchText.trim() !== '') {
      return this.examInfoList.filter(examInfo => examInfo.deptName === deptName);
    }
    
    // 原本的邏輯:從 allExamDetail 取得
    const examDetailList = this.allExamDetail[3];
    const targetDept = examDetailList.find(
      examDetail => examDetail.deptName === deptName
    );
    
    if (!targetDept || !targetDept.examItemList) {
      return [];
    }
    
    // 將 deptName 加入每個 examInfo
    return targetDept.examItemList.map(examInfo => ({
      ...examInfo,
      deptName: deptName
    }));
  }

  /**
   * 計算符合篩選條件的檢項總數(排除必檢項目和互斥檢項)
   */
  getFilteredExamsCount(): number {
    let count = 0;
    
    // 如果有搜尋文字，從 examInfoList 計算
    if (this.quickSearchText.trim() !== '') {
      // 過濾出符合分類篩選的檢項
      const filteredExams = this.selectedDeptNames.length === 0
        ? this.examInfoList
        : this.examInfoList.filter(exam => 
            exam.deptName && this.selectedDeptNames.includes(exam.deptName)
          );
      
      // 排除必檢項目、價格為0的項目和互斥檢項
      count = filteredExams.filter(exam => 
        !(exam.isNecessary && exam.isChoice) && 
        Number(exam.price) > 0 &&
        !this.mutexInfos.has(exam.examItem)
      ).length;
    } else {
      // 原本的邏輯：從 allExamDetail 計算
      for (const deptName of this.quickSearchDeptNames) {
        const deptExams = this.getExamInfosByDeptName(deptName);
        if (deptExams.length > 0 && (this.selectedDeptNames.length === 0 || this.selectedDeptNames.includes(deptName))) {
          count += deptExams.filter(exam => 
            !(exam.isNecessary && exam.isChoice) && 
            Number(exam.price) > 0 &&
            !this.mutexInfos.has(exam.examItem)
          ).length;
        }
      }
    }
    
    return count;
  }

  /**
   * 切換分類篩選下拉選單
   */
  toggleDeptFilter(deptName?: string, checked?: boolean) {
    if (deptName !== undefined && checked !== undefined) {
      // 處理 checkbox 變更
      if (checked) {
        this.selectedDeptNames.push(deptName);
      } else {
        this.selectedDeptNames = this.selectedDeptNames.filter(name => name !== deptName);
      }
      this.applyDeptFilters();
    } else {
      // 切換下拉選單開關
      this.isDeptFilterOpen = !this.isDeptFilterOpen;
    }
  }

  /**
   * 清除所有分類篩選
   */
  clearAllDeptFilters() {
    this.selectedDeptNames = [];
    this.quickSearchSelectedDeptName = '';
    this.applyDeptFilters();
  }

  /**
   * 套用分類篩選
   */
  applyDeptFilters() {
    // 根據選擇的科別進行篩選邏輯
    // 如果沒有選擇任何科別,顯示全部
    if (this.selectedDeptNames.length === 0) {
      this.quickSearchSelectedDeptName = '';
    }
  }


  // 監聽全域點擊事件 - 關閉分類篩選下拉選單
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.custom-multi-select');
    
    if (!clickedInside && this.isDeptFilterOpen) {
      this.isDeptFilterOpen = false;
    }
  }

  // 判斷是否所有高異常比例檢項都已加入
  get isAllHighAbnormalExamsAdded(): boolean {
    return this.combinedHighAbnormalExams.every(exam => 
      this.checkedExamItemSet.has(exam.examItem) || 
      this.checkedExamItemListUnderPackage.includes(exam.examItem) ||
      this.mutexInfos.has(exam.examItem)
    );
  }

  // 判斷是否所有中異常比例檢項都已加入
  get isAllMidAbnormalExamsAdded(): boolean {
    return this.basicCheckupMidAbnormalExams.every(exam => 
      this.checkedExamItemSet.has(exam.examItem) || 
      this.checkedExamItemListUnderPackage.includes(exam.examItem) ||
      this.mutexInfos.has(exam.examItem)
    );
  }

  // 判斷是否所有低異常比例檢項都已加入
  get isAllLowAbnormalExamsAdded(): boolean {
    return this.basicCheckupLowAbnormalExams.every(exam => 
      this.checkedExamItemSet.has(exam.examItem) || 
      this.checkedExamItemListUnderPackage.includes(exam.examItem) ||
      this.mutexInfos.has(exam.examItem)
    );
  }


  // 全部加入高異常比例檢項
  getAllAbnormalExams(): void {
    this.combinedHighAbnormalExams.forEach(examInfo => {
      // 檢查是否已經被選中或在互斥清單中
      const isAlreadyChecked = this.checkedExamItemSet.has(examInfo.examItem) || 
                              this.checkedExamItemListUnderPackage.includes(examInfo.examItem);
      const isMutex = this.mutexInfos.has(examInfo.examItem);
      
      // 只加入未選中且不在互斥清單的檢項
      if (!isAlreadyChecked && !isMutex) {
        this.toggleChecked(true, examInfo);
      }
    });
  }

  // 全部加入中異常比例檢項
  getAllMidAbnormalExams(): void {
    this.basicCheckupMidAbnormalExams.forEach(examInfo => {
      // 檢查是否已經被選中或在互斥清單中
      const isAlreadyChecked = this.checkedExamItemSet.has(examInfo.examItem) || 
                              this.checkedExamItemListUnderPackage.includes(examInfo.examItem);
      const isMutex = this.mutexInfos.has(examInfo.examItem);
      
      // 只加入未選中且不在互斥清單的檢項
      if (!isAlreadyChecked && !isMutex) {
        this.toggleChecked(true, examInfo);
      }
    });
  }

  // 全部加入低異常比例檢項
  getAllLowAbnormalExams(): void {
    this.basicCheckupLowAbnormalExams.forEach(examInfo => {
      // 檢查是否已經被選中或在互斥清單中
      const isAlreadyChecked = this.checkedExamItemSet.has(examInfo.examItem) || 
                              this.checkedExamItemListUnderPackage.includes(examInfo.examItem);
      const isMutex = this.mutexInfos.has(examInfo.examItem);
      
      // 只加入未選中且不在互斥清單的檢項
      if (!isAlreadyChecked && !isMutex) {
        this.toggleChecked(true, examInfo);
      }
    });
  } 

// 安心起步方案 - 取得異常追蹤和潛在疾病中異常比例51%~100%的檢項,排除 abnormalDetail 中的項目
get basicCheckupHighAbnormalExams(): AddExamInfo[] {
  const allExams: AddExamInfo[] = [];
  const reserveType = this.sharedStorageService.get('reserveType');
  
  const abnormalDetail = reserveType === '2'
    ? this.checkSuggestionsEnterpriseResponse?.abnormalDetail 
    : this.checkSuggestionsResponse?.abnormalDetail;
    
  const potentialDetail = reserveType === '2'
    ? this.checkSuggestionsEnterpriseResponse?.potentialDetail
    : this.checkSuggestionsResponse?.potentialDetail;

  // 建立 abnormalDetail 的 examItem Set,用於快速查找
  const abnormalExamItems = new Set<string>();
  if (this.hasAbnormalData) {
    abnormalDetail?.forEach(examDetail => {
      examDetail.examItemList?.forEach(examInfo => {
        abnormalExamItems.add(examInfo.examItem);
      });
    });
  }

  // 收集 potentialDetail 的檢項(排除 abnormalDetail 中的項目)
  potentialDetail?.forEach(examDetail => {
    examDetail.examItemList?.forEach(examInfo => {
      // 如果有 abnormalData,排除在 abnormalDetail 中的檢項
      if (this.hasAbnormalData && abnormalExamItems.has(examInfo.examItem)) {
        return;
      }
      
      const ratio = Math.round(Number(examInfo.abnormalRatio) * 100) || 0;
      if (ratio >= 51 && ratio <= 100) {
        const hasMutexWithNecessaryPackageItem = examInfo.mutexInfos?.some(mutexItem => {
          return this.examInfoListUnderPackage.some(packageExam => 
            packageExam.examItem === mutexItem && 
            packageExam.examType === this.examTypeText[0] && 
            packageExam.selectFlag === 1
          );
        }) ?? false;
        
        if (!hasMutexWithNecessaryPackageItem) {
          allExams.push(examInfo);
        }
      }
    });
  });

  return allExams.sort((a, b) => {
    const ratioA = Number(a.abnormalRatio) * 100 || 0;
    const ratioB = Number(b.abnormalRatio) * 100 || 0;
    return ratioB - ratioA;
  });
}

// 安心起步方案 - 取得異常追蹤和潛在疾病中異常比例21%~50%的檢項,排除 abnormalDetail 中的項目
get basicCheckupMidAbnormalExams(): AddExamInfo[] {
  const allExams: AddExamInfo[] = [];
  const reserveType = this.sharedStorageService.get('reserveType');
  
  const abnormalDetail = reserveType === '2'
    ? this.checkSuggestionsEnterpriseResponse?.abnormalDetail 
    : this.checkSuggestionsResponse?.abnormalDetail;
    
  const potentialDetail = reserveType === '2'
    ? this.checkSuggestionsEnterpriseResponse?.potentialDetail
    : this.checkSuggestionsResponse?.potentialDetail;

  // 建立 abnormalDetail 的 examItem Set
  const abnormalExamItems = new Set<string>();
  if (this.hasAbnormalData) {
    abnormalDetail?.forEach(examDetail => {
      examDetail.examItemList?.forEach(examInfo => {
        abnormalExamItems.add(examInfo.examItem);
      });
    });
  }

  // 收集 potentialDetail 的檢項(排除 abnormalDetail 中的項目)
  potentialDetail?.forEach(examDetail => {
    examDetail.examItemList?.forEach(examInfo => {
      if (this.hasAbnormalData && abnormalExamItems.has(examInfo.examItem)) {
        return;
      }
      
      const ratio = Math.round(Number(examInfo.abnormalRatio) * 100) || 0;
      if (ratio >= 21 && ratio <= 50) {
        const hasMutexWithNecessaryPackageItem = examInfo.mutexInfos?.some(mutexItem => {
          return this.examInfoListUnderPackage.some(packageExam => 
            packageExam.examItem === mutexItem && 
            packageExam.examType === this.examTypeText[0] && 
            packageExam.selectFlag === 1
          );
        }) ?? false;
        
        if (!hasMutexWithNecessaryPackageItem) {
          allExams.push(examInfo);
        }
      }
    });
  });

  return allExams.sort((a, b) => {
    const ratioA = Number(a.abnormalRatio) || 0;
    const ratioB = Number(b.abnormalRatio) || 0;
    return ratioB - ratioA;
  });
}

// 安心起步方案 - 取得異常追蹤和潛在疾病中異常比例0%~20%的檢項,排除 abnormalDetail 中的項目
get basicCheckupLowAbnormalExams(): AddExamInfo[] {
  const allExams: AddExamInfo[] = [];
  const reserveType = this.sharedStorageService.get('reserveType');
  
  const abnormalDetail = reserveType === '2'
    ? this.checkSuggestionsEnterpriseResponse?.abnormalDetail 
    : this.checkSuggestionsResponse?.abnormalDetail;
    
  const potentialDetail = reserveType === '2'
    ? this.checkSuggestionsEnterpriseResponse?.potentialDetail
    : this.checkSuggestionsResponse?.potentialDetail;

  // 建立 abnormalDetail 的 examItem Set
  const abnormalExamItems = new Set<string>();
  if (this.hasAbnormalData) {
    abnormalDetail?.forEach(examDetail => {
      examDetail.examItemList?.forEach(examInfo => {
        abnormalExamItems.add(examInfo.examItem);
      });
    });
  }

  // 收集 potentialDetail 的檢項(排除 abnormalDetail 中的項目)
  potentialDetail?.forEach(examDetail => {
    examDetail.examItemList?.forEach(examInfo => {
      if (this.hasAbnormalData && abnormalExamItems.has(examInfo.examItem)) {
        return;
      }
      
      const ratio = Math.round(Number(examInfo.abnormalRatio) * 100) || 0;
      if (ratio >= 0 && ratio <= 20) {
        const hasMutexWithNecessaryPackageItem = examInfo.mutexInfos?.some(mutexItem => {
          return this.examInfoListUnderPackage.some(packageExam => 
            packageExam.examItem === mutexItem && 
            packageExam.examType === this.examTypeText[0] && 
            packageExam.selectFlag === 1
          );
        }) ?? false;
        
        if (!hasMutexWithNecessaryPackageItem) {
          allExams.push(examInfo);
        }
      }
    });
  });

  return allExams.sort((a, b) => {
    const ratioA = Number(a.abnormalRatio) || 0;
    const ratioB = Number(b.abnormalRatio) || 0;
    return ratioB - ratioA;
  });
}

  // 計算已選擇的高異常比例檢項數量
  get selectedHighAbnormalCount(): number {
    return this.combinedHighAbnormalExams.filter(exam => 
      this.checkedExamItemSet.has(exam.examItem) || 
      this.checkedExamItemListUnderPackage.includes(exam.examItem)
    ).length;
  }

  // 計算已選擇的中異常比例檢查數量
  get selectedMidAbnormalCount(): number {
    return this.basicCheckupMidAbnormalExams.filter(exam =>
      this.checkedExamItemSet.has(exam.examItem) || 
      this.checkedExamItemListUnderPackage.includes(exam.examItem)
    ).length;
  }

  // 計算已選擇的低異常比例檢查數量
  get selectedLowAbnormalCount(): number {
    return this.basicCheckupLowAbnormalExams.filter(exam =>
      this.checkedExamItemSet.has(exam.examItem) || 
      this.checkedExamItemListUnderPackage.includes(exam.examItem)
    ).length;
  }

  // 取得高比例總數
  get totalHighAbnormalCount(): number {
    return this.combinedHighAbnormalExams.length;
  }

  // 取得中比例總數
  get totalMidAbnormalCount(): number {
    return this.basicCheckupMidAbnormalExams.length;
  }

  // 取得低比例總數
  get totalLowAbnormalCount(): number {
    return this.basicCheckupLowAbnormalExams.length;
  }

  // 判斷檢項是否為個人歷史異常項目
  isAbnormalExam(examItem: string): boolean {
    const reserveType = this.sharedStorageService.get('reserveType');
    
    const abnormalDetail = reserveType === '2'
      ? this.checkSuggestionsEnterpriseResponse?.abnormalDetail 
      : this.checkSuggestionsResponse?.abnormalDetail;
    
    if (!abnormalDetail) return false;
    
    return abnormalDetail.some(examDetail => 
      examDetail.examItemList?.some(item => item.examItem === examItem)
    );
  }

  getVisibleExams(exams: AddExamInfo[]): AddExamInfo[] {
    return exams.filter(examInfo => {
      // 過濾價格為 0 的檢項
      if (!examInfo.price || Number(examInfo.price) <= 0) {
        return false;
      }

      const reserveType = this.sharedStorageService.get('reserveType');
      
      // 檢查是否為方案內檢項
      const packageExam = this.examInfoListUnderPackage.find(
        (item: ExamInfo) => item.examItem === examInfo.examItem
      );
      
      if (packageExam) {
        // 沒有搜尋時,隱藏所有方案內檢項
        if (!this.quickSearchText || this.quickSearchText.trim() === '') {
          return false;
        }

        // 從會員中心調整檢項:過濾所有方案內檢項(不論 isNecessary)
        if (this.isFromMemberCenter) {
          return false;
        }
        
        // 個人預約:只過濾必檢項目
        if (reserveType === '1') {
          if (examInfo.isNecessary && examInfo.isChoice) {
            return false;
          }
        } 
        // 企業預約:過濾所有方案內檢項
        else if (reserveType === '2') {
          return false;
        }
      }

      // 過濾互斥檢項 - 企業
      if (this.mutexInfos.has(examInfo.examItem) && reserveType === '2') {
        return false;
      }
      
      // 過濾與方案內檢項互斥的檢項
      const hasMutexWithPackageItem = examInfo.mutexInfos?.some(mutexItem => 
        this.examInfoListUnderPackage.some(
          (item: ExamInfo) => item.examItem === mutexItem
        )
      ) ?? false;
      
      if (hasMutexWithPackageItem) {
        return false;
      }
      
      return true;
    }
  );
}

  expandedMemos = new Set<string>();

  shouldShowReadMore(examItem: string, element: HTMLElement): boolean {
    if (!element) return false;
    
    // 計算兩行的高度
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
    const maxHeight = lineHeight * 2;
    
    // 比較實際高度與最大高度
    return element.scrollHeight > maxHeight;
  }

  shouldShowTitleTooltip(examItem: string, element: HTMLElement): boolean {
    if (!element) return false;
    
    // 計算兩行的高度
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
    const maxHeight = lineHeight * 2;
    
    // 比較實際高度與最大高度
    return element.scrollHeight > maxHeight;
  }

  toggleMemo(event: Event, examItem: string) {
    event.stopPropagation();
    if (this.expandedMemos.has(examItem)) {
      this.expandedMemos.delete(examItem);
    } else {
      this.expandedMemos.add(examItem);
    }
  }

  // 檢查螢幕大小，判斷是否為行動裝置
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  // 新增: 合併紅字檢項和高風險檢項,紅字優先
  get combinedHighAbnormalExams(): AddExamInfo[] {
    const reserveType = this.sharedStorageService.get('reserveType');
    const abnormalDetail = reserveType === '2'
      ? this.checkSuggestionsEnterpriseResponse?.abnormalDetail 
      : this.checkSuggestionsResponse?.abnormalDetail;

    const abnormalExams: AddExamInfo[] = [];
    
    // 1. 先收集所有紅字檢項(abnormalDetail)
    if (this.hasAbnormalData && abnormalDetail) {
      abnormalDetail.forEach(examDetail => {
        examDetail.examItemList?.forEach(examInfo => {
          // 檢查是否與必檢項目互斥
          const hasMutexWithNecessaryPackageItem = examInfo.mutexInfos?.some(mutexItem => {
            return this.examInfoListUnderPackage.some(packageExam => 
              packageExam.examItem === mutexItem && 
              packageExam.examType === this.examTypeText[0] && 
              packageExam.selectFlag === 1
            );
          }) ?? false;
          
          // 檢查是否與方案內檢項互斥
          const hasMutexWithPackageItem = examInfo.mutexInfos?.some(mutexItem => 
            this.examInfoListUnderPackage.some(
              (item: ExamInfo) => item.examItem === mutexItem
            )
          ) ?? false;
          
          // 企業預約：檢查是否在 mutexInfos 中（包含 scs/sgs 相關互斥）
          const isInMutexInfos = reserveType === '2' && this.mutexInfos.has(examInfo.examItem);
        
          // 企業預約：額外檢查是否為 scs/sgs 相關互斥
          let isGiMutex = false;
          if (reserveType === '2') {
            const giInfo = this.checkSuggestionsEnterpriseResponse?.giInfo;
            if (giInfo) {
              const packageHasScs = this.examInfoListUnderPackage.some(item => 
                giInfo.scs?.includes(item.examItem)
              );
              const packageHasSgs = this.examInfoListUnderPackage.some(item => 
                giInfo.sgs?.includes(item.examItem)
              );
              
              // 如果方案內有 scs，檢查此檢項是否為其他 scs/nsCs/nsGi
              if (packageHasScs) {
                isGiMutex = giInfo.scs?.includes(examInfo.examItem) || 
                            giInfo.nsCs?.includes(examInfo.examItem) || 
                            giInfo.nsGi?.includes(examInfo.examItem);
              }
              
              // 如果方案內有 sgs，檢查此檢項是否為其他 sgs/nsGs/nsGi
              if (packageHasSgs) {
                isGiMutex = isGiMutex || 
                            giInfo.sgs?.includes(examInfo.examItem) || 
                            giInfo.nsGs?.includes(examInfo.examItem) || 
                            giInfo.nsGi?.includes(examInfo.examItem);
              }
            }
          }

          if (!hasMutexWithNecessaryPackageItem && !hasMutexWithPackageItem && !isInMutexInfos && !isGiMutex) {
            abnormalExams.push(examInfo);
          }

        });
      });
    }

    // 再加入高風險檢項(已經排除紅字檢項)，並套用相同的過濾邏輯，避免初始化出現 "檢查意義重複"
    const highAbnormalExams = this.basicCheckupHighAbnormalExams.filter(examInfo => {
      // 檢查是否與必檢項目互斥
      const hasMutexWithNecessaryPackageItem = examInfo.mutexInfos?.some(mutexItem => {
        return this.examInfoListUnderPackage.some(packageExam => 
          packageExam.examItem === mutexItem && 
          packageExam.examType === this.examTypeText[0] && 
          packageExam.selectFlag === 1
        );
      }) ?? false;
      
      // 檢查是否與方案內檢項互斥
      const hasMutexWithPackageItem = examInfo.mutexInfos?.some(mutexItem => 
        this.examInfoListUnderPackage.some(
          (item: ExamInfo) => item.examItem === mutexItem
        )
      ) ?? false;
      
      // 企業預約：檢查是否在 mutexInfos 中
      const isInMutexInfos = reserveType === '2' && this.mutexInfos.has(examInfo.examItem);

      // 企業預約：額外檢查是否為 scs/sgs 相關互斥
      let isGiMutex = false;
      if (reserveType === '2') {
        const giInfo = this.checkSuggestionsEnterpriseResponse?.giInfo;
        if (giInfo) {
          const packageHasScs = this.examInfoListUnderPackage.some(item => 
            giInfo.scs?.includes(item.examItem)
          );
          const packageHasSgs = this.examInfoListUnderPackage.some(item => 
            giInfo.sgs?.includes(item.examItem)
          );
          
          if (packageHasScs) {
            isGiMutex = giInfo.scs?.includes(examInfo.examItem) || 
                        giInfo.nsCs?.includes(examInfo.examItem) || 
                        giInfo.nsGi?.includes(examInfo.examItem);
          }
          
          if (packageHasSgs) {
            isGiMutex = isGiMutex || 
                        giInfo.sgs?.includes(examInfo.examItem) || 
                        giInfo.nsGs?.includes(examInfo.examItem) || 
                        giInfo.nsGi?.includes(examInfo.examItem);
          }
        }
      }

      return !hasMutexWithNecessaryPackageItem && !hasMutexWithPackageItem && !isInMutexInfos && !isGiMutex;
    });

    // 3. 合併並返回(紅字在前,高風險在後)
    return [...abnormalExams, ...highAbnormalExams];
  }
}
